/**
 * A function to create a log object for the 'clickToPreviewGiftCardProductSrc35Evid1' event (evid: 1)
 *
 * Event description: When the user clicked to preview the gift card product
 *
 * @param {clickToPreviewGiftCardProductSrc35Evid1Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToPreviewGiftCardProductSrc35Evid1Params>} LogObject<clickToPreviewGiftCardProductSrc35Evid1Params>
 */
export function clickToPreviewGiftCardProductSrc35Evid1(params) {
    return { evid: 1, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'testEvent' event (evid: 10)
 *
 * Event description: Test event.
 *
 * @param {testEventParams} params - The parameters for this event
 * @property {string} testName - test string
 * @return {LogObject<testEventParams>} LogObject<testEventParams>
 */
export function testEvent(params) {
    return { evid: 10, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'supportPopUpWasLoadedInIntegrationPageSrc35Evid100' event (evid: 100)
 *
 * Event description: When the user clicked on the application and the support pop-up loaded instead of the application.
 *
 * @param {supportPopUpWasLoadedInIntegrationPageSrc35Evid100Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} appName - The app that is in the integration process
 * @return {LogObject<supportPopUpWasLoadedInIntegrationPageSrc35Evid100Params>} LogObject<supportPopUpWasLoadedInIntegrationPageSrc35Evid100Params>
 */
export function supportPopUpWasLoadedInIntegrationPageSrc35Evid100(params) {
    return { evid: 100, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'attributionCreated' event (evid: 1000)
 *
 * Event description: When an attribution action was created
 *
 * @param {attributionCreatedParams} params - The parameters for this event
 * @property {GUID} giftCardId - Gift Card id, the attribution relates too
 * @property {GUID} accountMsid - Rise Account ID the GC belongs to
 * @property {GUID} fundingTransactionId - The transaction ID that its balance changes, decreases when redeemed from it or increases when "refunding" to it
 * @property {number} amountLong - The amount to be added (postive) / reduced (negative) multiplied by 100,000 (Currency based on Wallet Currency)
 * @property {GUID} attributionId - Attribution ID unique
 * @property {GUID} usingTransactionId - The transaction ID that uses or returns the amount from the FundingTransaction
 * @property {boolean} isLiability - If the funding transaction classified as a Liabillity. TRUE / FALSE / NULL
 * TRUE - when funding transaction_type is one of [INITIAL, STORE_CREDIT_REFUND]
 * FALSE - when funding transaction_type is one of  [REWARD, MANUAL, CAMPAIGN, MIGRATION]
 * NULL - when funding transaction_type is one of  [REDEEM, VOID, WALLET_ACTION_END]
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<attributionCreatedParams>} LogObject<attributionCreatedParams>
 */
export function attributionCreated(params) {
    return { evid: 1000, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnContactUsButtonSrc35Evid101' event (evid: 101)
 *
 * Event description: When the user clicked on "Contact Us" button
 *
 * @param {clickOnContactUsButtonSrc35Evid101Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnContactUsButtonSrc35Evid101Params>} LogObject<clickOnContactUsButtonSrc35Evid101Params>
 */
export function clickOnContactUsButtonSrc35Evid101(params) {
    return { evid: 101, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnDisableAppButtonInIntegrationPageSrc35Evid102' event (evid: 102)
 *
 * Event description: When the user clicks the "Disable app" button in the three-dot menu on the integration page
 *
 * @param {clickOnDisableAppButtonInIntegrationPageSrc35Evid102Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnDisableAppButtonInIntegrationPageSrc35Evid102Params>} LogObject<clickOnDisableAppButtonInIntegrationPageSrc35Evid102Params>
 */
export function clickOnDisableAppButtonInIntegrationPageSrc35Evid102(params) {
    return { evid: 102, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDisableIntegrationSrc35Evid103' event (evid: 103)
 *
 * Event description: When the user clicked to disable the integration
 *
 * @param {clickToDisableIntegrationSrc35Evid103Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickToDisableIntegrationSrc35Evid103Params>} LogObject<clickToDisableIntegrationSrc35Evid103Params>
 */
export function clickToDisableIntegrationSrc35Evid103(params) {
    return { evid: 103, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSwitchTabInIntegrationPageSrc35Evid104' event (evid: 104)
 *
 * Event description: When the user clicked on one of the tabs in the integration page
 *
 * @param {clickToSwitchTabInIntegrationPageSrc35Evid104Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} appTabName - All Apps / Retruns / Reviews / Marketing Automations / Other
 * @return {LogObject<clickToSwitchTabInIntegrationPageSrc35Evid104Params>} LogObject<clickToSwitchTabInIntegrationPageSrc35Evid104Params>
 */
export function clickToSwitchTabInIntegrationPageSrc35Evid104(params) {
    return { evid: 104, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOn3DotsInIntegrationPageSrc35Evid105' event (evid: 105)
 *
 * Event description: When the user clicked on 3 dots on the integration page
 *
 * @param {clickOn3DotsInIntegrationPageSrc35Evid105Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} appName - The app that is in the integration process
 * @return {LogObject<clickOn3DotsInIntegrationPageSrc35Evid105Params>} LogObject<clickOn3DotsInIntegrationPageSrc35Evid105Params>
 */
export function clickOn3DotsInIntegrationPageSrc35Evid105(params) {
    return { evid: 105, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenTheAddAppReviewModalSrc35Evid106' event (evid: 106)
 *
 * Event description: When the user click on the stars at the header modal to open the review modal
 *
 * @param {clickToOpenTheAddAppReviewModalSrc35Evid106Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {number} rate - the rate the user clicked on to open the modal (1-5)
 * @return {LogObject<clickToOpenTheAddAppReviewModalSrc35Evid106Params>} LogObject<clickToOpenTheAddAppReviewModalSrc35Evid106Params>
 */
export function clickToOpenTheAddAppReviewModalSrc35Evid106(params) {
    return { evid: 106, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSubmitAReviewSrc35Evid107' event (evid: 107)
 *
 * Event description: When the user click to submit / leave review on Shopify
 *
 * @param {clickToSubmitAReviewSrc35Evid107Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {number} rate - the rate the user clicked on to open the modal (1-5)
 * @property {string} note - The added note to a review (null when sent to Shopify)
 * @return {LogObject<clickToSubmitAReviewSrc35Evid107Params>} LogObject<clickToSubmitAReviewSrc35Evid107Params>
 */
export function clickToSubmitAReviewSrc35Evid107(params) {
    return { evid: 107, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCloseTheAddAppReviewHeaderSrc35Evid108' event (evid: 108)
 *
 * Event description: When the user click on the "x" on the header modal to close the header modal
 *
 * @param {clickToCloseTheAddAppReviewHeaderSrc35Evid108Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickToCloseTheAddAppReviewHeaderSrc35Evid108Params>} LogObject<clickToCloseTheAddAppReviewHeaderSrc35Evid108Params>
 */
export function clickToCloseTheAddAppReviewHeaderSrc35Evid108(params) {
    return { evid: 108, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenTheSetUpReminderModalSrc35Evid109' event (evid: 109)
 *
 * Event description: When the user clicked to toggle on / the user click on the "manage" button in order to open the modal to set up the reminders
 *
 * @param {clickToOpenTheSetUpReminderModalSrc35Evid109Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} type - gift_cards_reminders / store_credit_reminders
 * @return {LogObject<clickToOpenTheSetUpReminderModalSrc35Evid109Params>} LogObject<clickToOpenTheSetUpReminderModalSrc35Evid109Params>
 */
export function clickToOpenTheSetUpReminderModalSrc35Evid109(params) {
    return { evid: 109, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenIssueStoreCreditModal' event (evid: 11)
 *
 * Event description: when the user clicked to open modal of Issue SC from one of the entry points
 *
 * @param {clickToOpenIssueStoreCreditModalParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - main button / etc
 * @property {string} pageName - The page name where the action was created at
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @return {LogObject<clickToOpenIssueStoreCreditModalParams>} LogObject<clickToOpenIssueStoreCreditModalParams>
 */
export function clickToOpenIssueStoreCreditModal(params) {
    return { evid: 11, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSaveTheRemindersDetailsSrc35Evid110' event (evid: 110)
 *
 * Event description: When the user clicked save in the set up reminder modal
 *
 * @param {clickToSaveTheRemindersDetailsSrc35Evid110Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} type - gift_cards_reminders / store_credit_reminders
 * @property {number} balanceThreshold - The balance that a reminder would be sent only if it's above it
 * @property {string} remidnersPayload - JSON { a: {days,type} , b:{days,type} , c:{days,type}}
 * @return {LogObject<clickToSaveTheRemindersDetailsSrc35Evid110Params>} LogObject<clickToSaveTheRemindersDetailsSrc35Evid110Params>
 */
export function clickToSaveTheRemindersDetailsSrc35Evid110(params) {
    return { evid: 110, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'giftCardCreated' event (evid: 1101)
 *
 * Event description: When a GC was created, How can it happen?
 * Ways of creation:
 *      1. ORDER:
 *            a. Customer bought GC for himself
 *            b. Customer bought GC to someone else
 *      2. CAMPAIGN - Bulk from BO
 *      3. MIGRATION - GC that was created outside from Rise and migrated to the system
 *      4. STORE_CREDIT - Wallet created.
 *      5. MANUAL - From BO"
 *
 * @param {giftCardCreatedParams} params - The parameters for this event
 * @property {DateTime} expirationDate - Gift Card expiration date (null when no expiration was set)
 * @property {string} sourceChannelId - Channel ID associated with the created gift card , i.e. Shopify, Wix, Square, presented as unique key
 * @property {GUID} giftCardId - Gift card ID
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {string} orderId - When the gift card type is ORDER then this field will hold the order_id
 * @property {GUID} walletId - When the gift card type is STORE_CREDIT then this field will hold the wallet_id
 * @property {number} intialValueLong - Gift Card initial value multiplied by 100,000
 * @property {string} currency - GC currency, might be null (if null we'll use store currency defined by the site owner)
 * @property {string} hashedGiftCardCode - Hashed gift card code
 * @property {number} initialValueLong - Gift Card initial value multiplied by 100,000
 * @property {string} creationType - MANUAL - customer created gift card from the dashboard
 * ORDER - gift card was purchase
 * CAMPAIGN - bulk creation of gift cards
 * MIGRATION - gift card was migrated
 * STORE_CREDIT - Gift card was created for a wallet
 * @property {GUID} campaignId - When the gift card type is CAMPAIGN then this field will hold the campaign_id
 * @property {string} sourceTenantId - Tenant ID associated with the created gift card , i.e. shop ID (Shopify) , MSID (Wix)
 * @property {GUID} previousId - When the gift card type is MIGRATION then this field will hold the previous_id
 * @property {DateTime} createdDate - Gift Card creation date (from dev, not the implicit field)
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<giftCardCreatedParams>} LogObject<giftCardCreatedParams>
 */
export function giftCardCreated(params) {
    return { evid: 1101, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'giftCardUpdated' event (evid: 1102)
 *
 * Event description: When Balance or expiration date were changed
 *
 * @param {giftCardUpdatedParams} params - The parameters for this event
 * @property {DateTime} expirationDate - Gift Card expiration date (null when no expiration was set)
 * @property {string} sourceChannelId - Channel ID associated with the created gift card , i.e. Shopify, Wix, Square, presented as unique key
 * @property {GUID} giftCardId - Gift card ID
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {number} newBalanceLong - New GC Balance amount multiplied by 100,000
 * @property {GUID} lastTransactionId - The transaction id which set the new balance (NEVER NULL) always hold the last transaction ID which updated the balance
 * @property {number} balanceLong - balance_long
 * @property {number} intialValueLong - Gift Card initial value multiplied by 100,000
 * @property {string} currency - GC currency, might be null (if null we'll use store currency defined by the site owner)
 * @property {string} hashedGiftCardCode - Hashed gift card code
 * @property {number} initialValueLong - Gift Card initial value multiplied by 100,000
 * @property {string} sourceTenantId - Tenant ID associated with the created gift card , i.e. shop ID (Shopify) , MSID (Wix)
 * @property {DateTime} createdDate - Gift Card creation date (from dev, not the implicit field)
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<giftCardUpdatedParams>} LogObject<giftCardUpdatedParams>
 */
export function giftCardUpdated(params) {
    return { evid: 1102, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'transactionCreated' event (evid: 1103)
 *
 * Event description: When a transaction was created
 * Ways of creation:
 * 1. REDEEM - The customer used the GC in checkout. (decrease)
 * 2. VOID - Revert transaction --> transaction_id (increase)
 * 3. REWARD (only wallets) - From walletAction (increase)
 * 4. WALLET_ACTION_END (only wallets) - From walletActions when the reward expired (decrease)
 * 5. MANUAL - From BO, can happen in GC and Wallet as well. (increase / decrease)
 * 6. CAMPAIGN - GC creation BO (create initial balance - increase)
 * 7. STORE_CREDIT_REFUND (only wallets) - Refund options from walletAction - (increase)
 * 8. MIGRATION - Copy of the old transactions (increase / decrease)
 * 9. INITIAL - 1st transaction in each GC creation (increase)
 * 10. PAYMENT_METHOD_REFUND - when an order was cancelled, the redeemed amount returns to the GC - (increase)
 *
 * @param {transactionCreatedParams} params - The parameters for this event
 * @property {string} sourceChannelId - Channel ID associated with the transaction , i.e. Shopify, Wix, Square, presented as unique key
 * @property {GUID} giftCardId - Gift card ID
 * @property {GUID} voidedTransactionId - When the transaction type is VOID then this field will hold the voided_transaction_id
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {number} amountLong - Transaction amount multiplied by 100,000
 * @property {string} orderId - When the transaction type is REDEEM / PAYMENT_METHOD_REFUND then this field will hold the order_id
 * @property {string} operationType - ADD / SUBTRACT
 * @property {string} transactionType - "The type can be one of these :
 *  {REDEEM, VOID, REWARD, WALLET_ACTION_END, MANUAL, CAMPAIGN , STORE_CREDIT_REFUND, MIGRATION, INITIAL, PAYMENT_METHOD_REFUND }"
 * @property {GUID} previousTransactionId - When the transaction type is WALLET_ACTION_END / MIGRATION then this field will hold the previous_transaction_id
 * @property {GUID} campaignId - When the transaction type is CAMPAIGN then this field will hold the campaign_id
 * @property {GUID} walletActionId - When the transaction type is REWARD / WALLET_ACTION_END / STORE_CREDIT_REFUND then this field will hold the wallet_action_id
 * @property {string} sourceTenantId - Tenant ID associated with the transaction , i.e. shop ID (Shopify) , MSID (Wix)
 * @property {GUID} transactionId - Transaction ID
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<transactionCreatedParams>} LogObject<transactionCreatedParams>
 */
export function transactionCreated(params) {
    return { evid: 1103, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'giftCardDisabled' event (evid: 1104)
 *
 * Event description: When Get Gift Card was disabled. irreversible action, when a GC is disabled it will stay as that.
 *
 * @param {giftCardDisabledParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {GUID} giftCardId - Gift card ID
 * @return {LogObject<giftCardDisabledParams>} LogObject<giftCardDisabledParams>
 */
export function giftCardDisabled(params) {
    return { evid: 1104, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSkipOnTheOnboardingFunnelSrc35Evid111' event (evid: 111)
 *
 * Event description: When the user clicked to skip on the onboarding funnel
 *
 * @param {clickToSkipOnTheOnboardingFunnelSrc35Evid111Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} currentStep - The step the user clicked to skip from
 * @property {string} payload - Array of all the argument the user chose before clicked to skip
 * @return {LogObject<clickToSkipOnTheOnboardingFunnelSrc35Evid111Params>} LogObject<clickToSkipOnTheOnboardingFunnelSrc35Evid111Params>
 */
export function clickToSkipOnTheOnboardingFunnelSrc35Evid111(params) {
    return { evid: 111, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getGiftCard' event (evid: 1111)
 *
 * Event description: When Get Gift Card API call executed
 *
 * @param {getGiftCardParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {GUID} giftCardId - Gift card ID
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<getGiftCardParams>} LogObject<getGiftCardParams>
 */
export function getGiftCard(params) {
    return { evid: 1111, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'queryGiftCards' event (evid: 1112)
 *
 * Event description: When Query Gift Cards API call executed
 *
 * @param {queryGiftCardsParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {string} giftCardIds - Array of the gift cards that were queried [ giftCardID_1, giftCardID_2, ...]
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<queryGiftCardsParams>} LogObject<queryGiftCardsParams>
 */
export function queryGiftCards(params) {
    return { evid: 1112, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'queryTransactions' event (evid: 1113)
 *
 * Event description: When Query Transactions API call executed
 *
 * @param {queryTransactionsParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {string} transactionIds - Array of the transactions that were queried [transactionID_1, transactionID_2, ...]
 * @property {string} meta_site_id - msid
 * @return {LogObject<queryTransactionsParams>} LogObject<queryTransactionsParams>
 */
export function queryTransactions(params) {
    return { evid: 1113, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToContinueInTheOnboardingFunnelSrc35Evid112' event (evid: 112)
 *
 * Event description: When the user clicked to continue to the next step of the onboarding funnel
 *
 * @param {clickToContinueInTheOnboardingFunnelSrc35Evid112Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} currentStep - The BI slug from Wix flows. Identify the name of the current step
 * @property {string} payload - Array of all the argument the user chose before continued
 * @property {string} currentStepId - The ID of the current step page
 * @property {string} nextStep - The step the user will move to
 * @return {LogObject<clickToContinueInTheOnboardingFunnelSrc35Evid112Params>} LogObject<clickToContinueInTheOnboardingFunnelSrc35Evid112Params>
 */
export function clickToContinueInTheOnboardingFunnelSrc35Evid112(params) {
    return { evid: 112, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenDisableCreditModalSrc35Evid113' event (evid: 113)
 *
 * Event description: When the user clicked on the disable credit button to open the modal
 *
 * @param {clickToOpenDisableCreditModalSrc35Evid113Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} transactionType - The type of the clicked transaction
 * @property {GUID} transactionId - the ID of the clicked transaction
 * @return {LogObject<clickToOpenDisableCreditModalSrc35Evid113Params>} LogObject<clickToOpenDisableCreditModalSrc35Evid113Params>
 */
export function clickToOpenDisableCreditModalSrc35Evid113(params) {
    return { evid: 113, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDisableCreditSrc35Evid114' event (evid: 114)
 *
 * Event description: When the user clicked on the disable credit button in the modal
 *
 * @param {clickToDisableCreditSrc35Evid114Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} transactionType - The type of the clicked transaction
 * @property {GUID} transactionId - the ID of the clicked transaction
 * @return {LogObject<clickToDisableCreditSrc35Evid114Params>} LogObject<clickToDisableCreditSrc35Evid114Params>
 */
export function clickToDisableCreditSrc35Evid114(params) {
    return { evid: 114, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSwitchTabOnPendingGiftCardPageSrc35Evid115' event (evid: 115)
 *
 * Event description: When the user switch tabs on the notification page between pending to declined
 *
 * @param {clickToSwitchTabOnPendingGiftCardPageSrc35Evid115Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} switchedTo - The value of the click to switch to pending / declined
 * @return {LogObject<clickToSwitchTabOnPendingGiftCardPageSrc35Evid115Params>} LogObject<clickToSwitchTabOnPendingGiftCardPageSrc35Evid115Params>
 */
export function clickToSwitchTabOnPendingGiftCardPageSrc35Evid115(params) {
    return { evid: 115, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGiftCardDetailsInPendingGiftCardPageSrc35Evid116' event (evid: 116)
 *
 * Event description: Clicked on a specific gift card in the pending gift card table
 *
 * @param {clickOnGiftCardDetailsInPendingGiftCardPageSrc35Evid116Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} sourceTenantId - The shop associated with the action
 * @property {string} orderStatus - Fraud risk / pending payment
 * @property {number} orderNumber - The order associated with the action
 * @return {LogObject<clickOnGiftCardDetailsInPendingGiftCardPageSrc35Evid116Params>} LogObject<clickOnGiftCardDetailsInPendingGiftCardPageSrc35Evid116Params>
 */
export function clickOnGiftCardDetailsInPendingGiftCardPageSrc35Evid116(params) {
    return { evid: 116, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCreateGiftCardInPendingGiftCardsPageSrc35Evid117' event (evid: 117)
 *
 * Event description: When the user approved the order and created a gift card
 *
 * @param {clickToCreateGiftCardInPendingGiftCardsPageSrc35Evid117Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} sourceTenantId - The shop associated with the action
 * @property {number} orderNumber - The order associated with the action
 * @return {LogObject<clickToCreateGiftCardInPendingGiftCardsPageSrc35Evid117Params>} LogObject<clickToCreateGiftCardInPendingGiftCardsPageSrc35Evid117Params>
 */
export function clickToCreateGiftCardInPendingGiftCardsPageSrc35Evid117(params) {
    return { evid: 117, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDeclineOrderInPendingGiftCardsPageSrc35Evid118' event (evid: 118)
 *
 * Event description: When the user declined the order in the pending gift card page
 *
 * @param {clickToDeclineOrderInPendingGiftCardsPageSrc35Evid118Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} sourceTenantId - The shop associated with the action
 * @property {number} orderNumber - The order associated with the action
 * @return {LogObject<clickToDeclineOrderInPendingGiftCardsPageSrc35Evid118Params>} LogObject<clickToDeclineOrderInPendingGiftCardsPageSrc35Evid118Params>
 */
export function clickToDeclineOrderInPendingGiftCardsPageSrc35Evid118(params) {
    return { evid: 118, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnCreateAPassButtonForTheFirstTimeSrc35Evid119' event (evid: 119)
 *
 * Event description: When the user clicks the 'Create a Pass' button in the Wallet pass page for the first time
 *
 * @param {clickOnCreateAPassButtonForTheFirstTimeSrc35Evid119Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnCreateAPassButtonForTheFirstTimeSrc35Evid119Params>} LogObject<clickOnCreateAPassButtonForTheFirstTimeSrc35Evid119Params>
 */
export function clickOnCreateAPassButtonForTheFirstTimeSrc35Evid119(params) {
    return { evid: 119, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'issueStoreCreditModalOpened' event (evid: 12)
 *
 * Event description: When the Issue store credit modal opened
 *
 * @param {issueStoreCreditModalOpenedParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - main button / etc
 * @property {string} pageName - The page name where the action was created at
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @return {LogObject<issueStoreCreditModalOpenedParams>} LogObject<issueStoreCreditModalOpenedParams>
 */
export function issueStoreCreditModalOpened(params) {
    return { evid: 12, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnUploadButtonForWalletPassSrc35Evid120' event (evid: 120)
 *
 * Event description: When the user clicks to upload an image in wallet pass page
 *
 * @param {clickOnUploadButtonForWalletPassSrc35Evid120Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} imageType - Apple logo / Google logo / Banner
 * @property {string} type - Upload / Replace
 * @return {LogObject<clickOnUploadButtonForWalletPassSrc35Evid120Params>} LogObject<clickOnUploadButtonForWalletPassSrc35Evid120Params>
 */
export function clickOnUploadButtonForWalletPassSrc35Evid120(params) {
    return { evid: 120, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'walletCreated' event (evid: 1201)
 *
 * Event description: When a Wallet entity was created.
 * When a wallet is created, it means a customerReference was created too.(received store credits)
 *
 * @param {walletCreatedParams} params - The parameters for this event
 * @property {string} sourceChannelId - CustomerReference details - tenantId associated with the CustomerReference , i.e. shop ID (Shopify) , MSID (Wix)
 * @property {GUID} giftCardId - Represents the Gift Card associated with this Wallet
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {string} sourceCustomerId - CustomerReference details - CustomerID associated with the CustomerReference, i.e user id (Shopify) ,contact_id/member_id (Wix)
 * @property {GUID} walletId - Wallet ID
 * @property {GUID} contactId - WixContactId - CustomerReference details - contactId who received the stores credit
 * @property {string} customerReferenceId - CustomerReference hashed string of : sourceChannelId+sourceCustomerId+sourceTenantId
 * @property {string} currency - GC currency, might be null (if null we'll use store currency defined by the site owner)
 * @property {string} hashedGiftCardCode - Hashed gift card code
 * @property {string} sourceTenantId - CustomerReference details - tenantId associated with the CustomerReference , i.e. shop ID (Shopify) , MSID (Wix)
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<walletCreatedParams>} LogObject<walletCreatedParams>
 */
export function walletCreated(params) {
    return { evid: 1201, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'walletUpdated' event (evid: 1202)
 *
 * Event description: When the Wallet entity was updated.
 * The wallet can be updated in one of three ways:
 * CustomerReference was created, deleted, or updated.
 * CustomerReference details refer to the customer that the action was applied on.
 *
 * @param {walletUpdatedParams} params - The parameters for this event
 * @property {string} sourceChannelId - CustomerReference details - source channel associated with the CustomerReference , i.e. Shopify, Wix, Square
 * @property {GUID} giftCardId - Represents the Gift Card associated with this Wallet
 * @property {number} numberOfContacts - The number of Customers the wallet has after the update.
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {string} sourceCustomerId - CustomerReference details - CustomerID associated with the CustomerReference, i.e user id (Shopify) , member id/contact id (Wix)
 * @property {GUID} walletId - Wallet ID
 * @property {string} updateType - The event is sent in 1 of 3 options:
 * 1 - New CustomerReference added to Wallet = CustomerReference Created = "CREATED"
 * 2 - Existing CustomerReference removed from Wallet = CustomerReference Deleted = "DELETED"
 * 3 - Existing CustomerReference fields were updated = CustomerReference Updated = "UPDATED"
 * **Only PII details can be updated, so we will not see any change in the updated CustomerReference.
 * @property {GUID} contactId - WixContactId - CustomerReference details - contactId who received the stores credit
 * @property {string} customerReferenceId - CustomerReference hashed string of : sourceChannelId+sourceCustomerId+sourceTenantId
 * @property {boolean} isActive - If the wallet is in "Zombie" mode (0 Customer IDs) - False
 * @property {string} sourceTenantId - CustomerReference details - tenantId associated with the CustomerReference , i.e. shop ID (Shopify) , MSID (Wix)
 * @property {string} walletCustomerReferenceIds - Array of the CustomerReferernce IDs associated with the wallet after the update  [customerReferenceId1, customerReferenceId2, ...]
 * @property {string} walletContactIds - Array of the Contact IDs associated with the wallet after the update [ContactId1, ContactId2, ...]
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<walletUpdatedParams>} LogObject<walletUpdatedParams>
 */
export function walletUpdated(params) {
    return { evid: 1202, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixContactCreated' event (evid: 1203)
 *
 * Event description: Action event to connect between Customer Reference ID to Wix Contact ID
 *
 * @param {wixContactCreatedParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {GUID} contactId - WixContactId - CustomerReference details - contactId who received the stores credit
 * @property {string} customerReferenceId - CustomerReference hashed string of : sourceChannelId+sourceCustomerId+sourceTenantId
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<wixContactCreatedParams>} LogObject<wixContactCreatedParams>
 */
export function wixContactCreated(params) {
    return { evid: 1203, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnSwitchAppleGoggleViewsSrc35Evid121' event (evid: 121)
 *
 * Event description: When the user clicks to switch the views between apple / google in wallet pass page
 *
 * @param {clickOnSwitchAppleGoggleViewsSrc35Evid121Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} viewName - Apple / Google
 * @return {LogObject<clickOnSwitchAppleGoggleViewsSrc35Evid121Params>} LogObject<clickOnSwitchAppleGoggleViewsSrc35Evid121Params>
 */
export function clickOnSwitchAppleGoggleViewsSrc35Evid121(params) {
    return { evid: 121, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getCustomerRef' event (evid: 1211)
 *
 * Event description: When Get Customer Ref API call executed
 *
 * @param {getCustomerRefParams} params - The parameters for this event
 * @property {string} sourceChannelId - CustomerReference details - source channel associated with the CustomerReference , i.e. Shopify, Wix, Square, presented as unique key
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {string} sourceCustomerId - CustomerReference details - CustomerID associated with the CustomerReference, i.e user id (Shopify) ,contact_id/member_id (Wix)
 * @property {GUID} walletId - Wallet ID
 * @property {GUID} contactId - CustomerReference details - contactId who received the stores credit (WixContactId)
 * @property {string} sourceTenantId - CustomerReference details - tenantId associated with the CustomerReference , i.e. shop ID (Shopify) , MSID (Wix)
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<getCustomerRefParams>} LogObject<getCustomerRefParams>
 */
export function getCustomerRef(params) {
    return { evid: 1211, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getWallet' event (evid: 1212)
 *
 * Event description: When Get Wallet API call executed
 *
 * @param {getWalletParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {GUID} walletId - Wallet ID
 * @property {string} queryType - What was the query field. one of - Wallet ID, Email, CustomerReference source
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<getWalletParams>} LogObject<getWalletParams>
 */
export function getWallet(params) {
    return { evid: 1212, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getWalletGiftCard' event (evid: 1213)
 *
 * Event description: When Get Wallet Gift Card API call executed
 *
 * @param {getWalletGiftCardParams} params - The parameters for this event
 * @property {GUID} giftCardId - Represents the Gift Card associated with this Wallet
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {GUID} walletId - Wallet ID
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<getWalletGiftCardParams>} LogObject<getWalletGiftCardParams>
 */
export function getWalletGiftCard(params) {
    return { evid: 1213, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'queryWallets' event (evid: 1214)
 *
 * Event description: When Query Wallets API call executed
 *
 * @param {queryWalletsParams} params - The parameters for this event
 * @property {string} walletIds - Array with all the wallets that were queried [walletID_1, walletID_2, ...]
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<queryWalletsParams>} LogObject<queryWalletsParams>
 */
export function queryWallets(params) {
    return { evid: 1214, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnCopyPassLinkSrc35Evid122' event (evid: 122)
 *
 * Event description: When the user clicks to copy pass link in wallet pass page (would not be implemented in p1)
 *
 * @param {clickOnCopyPassLinkSrc35Evid122Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - The entry point
 * @return {LogObject<clickOnCopyPassLinkSrc35Evid122Params>} LogObject<clickOnCopyPassLinkSrc35Evid122Params>
 */
export function clickOnCopyPassLinkSrc35Evid122(params) {
    return { evid: 122, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnSaveAWalletPassSrc35Evid123' event (evid: 123)
 *
 * Event description: When the user clicks to save the wallet pass for the first time or clicks on save in apply changes modal
 *
 * @param {clickOnSaveAWalletPassSrc35Evid123Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {boolean} isFirstTime - sends true if the save is the first time from wallet pass page / false if it is from apply changes modal
 * @return {LogObject<clickOnSaveAWalletPassSrc35Evid123Params>} LogObject<clickOnSaveAWalletPassSrc35Evid123Params>
 */
export function clickOnSaveAWalletPassSrc35Evid123(params) {
    return { evid: 123, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnSaveChangesOfWalletPassSrc35Evid124' event (evid: 124)
 *
 * Event description: When the user clicks click on save changes of exisiting wallet pass to open the apply changes modal
 *
 * @param {clickOnSaveChangesOfWalletPassSrc35Evid124Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnSaveChangesOfWalletPassSrc35Evid124Params>} LogObject<clickOnSaveChangesOfWalletPassSrc35Evid124Params>
 */
export function clickOnSaveChangesOfWalletPassSrc35Evid124(params) {
    return { evid: 124, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnRemoveAnImageInWalletPassSrc35Evid125' event (evid: 125)
 *
 * Event description: When the user clicks to remove an image in the wallet pass page
 *
 * @param {clickOnRemoveAnImageInWalletPassSrc35Evid125Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} imageType - Apple logo / Google logo / Banner
 * @return {LogObject<clickOnRemoveAnImageInWalletPassSrc35Evid125Params>} LogObject<clickOnRemoveAnImageInWalletPassSrc35Evid125Params>
 */
export function clickOnRemoveAnImageInWalletPassSrc35Evid125(params) {
    return { evid: 125, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToReplaceAnImageInWalletPassSrc35Evid126' event (evid: 126)
 *
 * Event description: When the user clicks to replace n image in the wallet pass page
 *
 * @param {clickToReplaceAnImageInWalletPassSrc35Evid126Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} imageType - Apple logo / Google logo / Banner
 * @return {LogObject<clickToReplaceAnImageInWalletPassSrc35Evid126Params>} LogObject<clickToReplaceAnImageInWalletPassSrc35Evid126Params>
 */
export function clickToReplaceAnImageInWalletPassSrc35Evid126(params) {
    return { evid: 126, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheActiveDisabledToggleInEmailEditorSrc35Evid127' event (evid: 127)
 *
 * Event description: When the user clicked to switch the state of the active / disabled action toggle button in email editor
 *
 *
 * @param {clickOnTheActiveDisabledToggleInEmailEditorSrc35Evid127Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} switch_to - active / disabled
 * @property {string} toggleName - The name of the selected toggle
 * @return {LogObject<clickOnTheActiveDisabledToggleInEmailEditorSrc35Evid127Params>} LogObject<clickOnTheActiveDisabledToggleInEmailEditorSrc35Evid127Params>
 */
export function clickOnTheActiveDisabledToggleInEmailEditorSrc35Evid127(params) {
    return { evid: 127, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid128' event (evid: 128)
 *
 * Event description: Click to send an invite to anew member
 *
 * @param {clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid128Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} role - the role the invitation sent with: admin / operator / custom
 * @return {LogObject<clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid128Params>} LogObject<clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid128Params>
 */
export function clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid128(params) {
    return { evid: 128, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckedUncheckedAddSenderDetailsSrc35Evid129' event (evid: 129)
 *
 * Event description: When the user check / uncheck the checkbox of "Add sender details" in issue gift card modal
 *
 * @param {clickToCheckedUncheckedAddSenderDetailsSrc35Evid129Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {boolean} isChecked - TRUE / FALSE
 * @return {LogObject<clickToCheckedUncheckedAddSenderDetailsSrc35Evid129Params>} LogObject<clickToCheckedUncheckedAddSenderDetailsSrc35Evid129Params>
 */
export function clickToCheckedUncheckedAddSenderDetailsSrc35Evid129(params) {
    return { evid: 129, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckedUncheckedExpirationDate' event (evid: 13)
 *
 * Event description: When the user checked / unchecked the checkbox of "Add Expiration" date
 *
 * @param {clickToCheckedUncheckedExpirationDateParams} params - The parameters for this event
 * @property {boolean} isChecked - TRUE / FALSE
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {string} pageName - The page name where the action was created at
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @return {LogObject<clickToCheckedUncheckedExpirationDateParams>} LogObject<clickToCheckedUncheckedExpirationDateParams>
 */
export function clickToCheckedUncheckedExpirationDate(params) {
    return { evid: 13, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenWalletPageSrc35Evid130' event (evid: 130)
 *
 * Event description: When the user clicked on a wallet in the "wallets List" or through another entry point which leads to the "wallet page"
 *
 * @param {clickToOpenWalletPageSrc35Evid130Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - cairo / etc
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickToOpenWalletPageSrc35Evid130Params>} LogObject<clickToOpenWalletPageSrc35Evid130Params>
 */
export function clickToOpenWalletPageSrc35Evid130(params) {
    return { evid: 130, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'walletActionCreated' event (evid: 1301)
 *
 * Event description: When a walletAction was created.
 * How can it happens?
 *     1. All the ways of creation store credit (reward / refund)
 *
 * @param {walletActionCreatedParams} params - The parameters for this event
 * @property {DateTime} expirationDate - Represents the time when the unused balance will be deducted from the account. NULL - no expiration date set
 * @property {GUID} giftCardId - Gift Card ID
 * @property {GUID} accountMsid - Rise Account ID the wallet belongs to
 * @property {number} amountLong - The amount to be added / reduced multiplied by 100,000 (Currency based on Wallet Currency)
 * @property {GUID} walletId - Wallet ID the event is belongs to
 * @property {string} note - free text comment regarding the WalletAction context
 * @property {string} creationType - The WalletAction creation type - REWARD / REFUND
 * @property {GUID} walletActionId - walletAction ID
 * @property {string} startDate - Represents the time when the WalletActions' amount will be added to the account. NULL when the WalletAction started immediately
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<walletActionCreatedParams>} LogObject<walletActionCreatedParams>
 */
export function walletActionCreated(params) {
    return { evid: 1301, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventUpdated' event (evid: 1302)
 *
 * Event description: When the walletAction updated manually and changed (startDate, expiratiodDate, Note)
 *
 * @param {eventUpdatedParams} params - The parameters for this event
 * @property {DateTime} expirationDate - Represents the time when the unused balance will be deducted from the account. NULL - no expiration date set
 * @property {GUID} giftCardId - Gift Card ID
 * @property {GUID} accountMsid - The Account ID the wallet belongs to
 * @property {number} amountLong - The amount to be added / reduced multiplied by 100,000 (Currency based on Wallet Currency)
 * @property {GUID} walletId - Wallet ID the event is belongs to
 * @property {string} note - free text comment regarding the WalletAction context
 * @property {string} creationType - The WalletAction creation type - REWARD / REFUND
 * @property {GUID} walletActionId - walletAction ID
 * @property {string} startDate - Represents the time when the WalletActions' amount will be added to the account. NULL when the WalletAction started immediately
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<eventUpdatedParams>} LogObject<eventUpdatedParams>
 */
export function eventUpdated(params) {
    return { evid: 1302, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventDisabledExpired' event (evid: 1303)
 *
 * Event description: When the expiration date arrived or disabled API call arrived  --> the reversed transaction created
 *
 * @param {eventDisabledExpiredParams} params - The parameters for this event
 * @property {DateTime} expirationDate - Represents the time when the unused balance will be deducted from the account
 * @property {GUID} giftCardId - Gift Card ID
 * @property {GUID} accountMsid - Rise Account ID the wallet belongs to
 * @property {number} amountLong - The amount to be added / reduced multiplied by 100,000 (Currency based on Wallet Currency)
 * @property {string} updatedType - When the update was because a manual API call - DISABLED, When the experation date that set arrived -  EXPIRATION_DATE
 * @property {GUID} walletId - Wallet ID the event is belongs to
 * @property {string} note - free text comment regarding the walletAction context
 * @property {string} creationType - The WalletAction creation type - REWARD / REFUND
 * @property {GUID} walletActionId - walletAction ID
 * @property {string} startDate - Represents the time when the walletActions' amount will be added to the account. NULL when the walletAction started immediately
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<eventDisabledExpiredParams>} LogObject<eventDisabledExpiredParams>
 */
export function eventDisabledExpired(params) {
    return { evid: 1303, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventDeleted' event (evid: 1304)
 *
 * Event description: When a walletAction was deleted. only avilable to walletActions which haven't started
 *
 * @param {eventDeletedParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the wallet belongs to
 * @property {GUID} walletActionId - walletAction ID
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<eventDeletedParams>} LogObject<eventDeletedParams>
 */
export function eventDeleted(params) {
    return { evid: 1304, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDeleteCustomEmailTemplateSrc35Evid131' event (evid: 131)
 *
 * Event description: When the user click to delete a custom template
 *
 * @param {clickToDeleteCustomEmailTemplateSrc35Evid131Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToDeleteCustomEmailTemplateSrc35Evid131Params>} LogObject<clickToDeleteCustomEmailTemplateSrc35Evid131Params>
 */
export function clickToDeleteCustomEmailTemplateSrc35Evid131(params) {
    return { evid: 131, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getEvent' event (evid: 1311)
 *
 * Event description: When Get WalletAction API call executed
 *
 * @param {getEventParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the wallet belongs to
 * @property {GUID} walletActionId - walletAction ID
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<getEventParams>} LogObject<getEventParams>
 */
export function getEvent(params) {
    return { evid: 1311, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'queryEvents' event (evid: 1312)
 *
 * Event description: When Query WalletActions API call executed
 *
 * @param {queryEventsParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID the wallet belongs to
 * @property {string} walletActionIds - Array with all the walletActions that were queried - [walletActionID_1, walletActionID_2, ...]
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<queryEventsParams>} LogObject<queryEventsParams>
 */
export function queryEvents(params) {
    return { evid: 1312, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'queryWalletActionBalances' event (evid: 1313)
 *
 * Event description: When Query WalletAction Balances call executed
 *
 * @param {queryWalletActionBalancesParams} params - The parameters for this event
 * @property {GUID} eventId - Rise Event ID
 * @property {GUID} accountMsid - Rise Account ID the Wallet belongs to
 * @property {GUID} meta_site_id - msid
 * @return {LogObject<queryWalletActionBalancesParams>} LogObject<queryWalletActionBalancesParams>
 */
export function queryWalletActionBalances(params) {
    return { evid: 1313, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEditWithRegularEditorButtonInEmailBuilderPageCopySrc35Evid132' event (evid: 132)
 *
 * Event description: When the user clicked on the edit with regular editor button to edit with code the email
 *
 * @param {clickOnEditWithRegularEditorButtonInEmailBuilderPageCopySrc35Evid132Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {string} templateId - The id of the template
 * @return {LogObject<clickOnEditWithRegularEditorButtonInEmailBuilderPageCopySrc35Evid132Params>} LogObject<clickOnEditWithRegularEditorButtonInEmailBuilderPageCopySrc35Evid132Params>
 */
export function clickOnEditWithRegularEditorButtonInEmailBuilderPageCopySrc35Evid132(params) {
    return { evid: 132, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid133' event (evid: 133)
 *
 * Event description: When the user clicked to switch to the Regula editor in the email builder
 *
 * @param {clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid133Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {string} templateId - The id of the template
 * @return {LogObject<clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid133Params>} LogObject<clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid133Params>
 */
export function clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid133(params) {
    return { evid: 133, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheCreateWebhookButtonSrc35Evid134' event (evid: 134)
 *
 * Event description: When the user click on the button to create a webhook
 *
 * @param {clickOnTheCreateWebhookButtonSrc35Evid134Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - the place in the page the button was placed at
 * @return {LogObject<clickOnTheCreateWebhookButtonSrc35Evid134Params>} LogObject<clickOnTheCreateWebhookButtonSrc35Evid134Params>
 */
export function clickOnTheCreateWebhookButtonSrc35Evid134(params) {
    return { evid: 134, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenDeveloperToolSrc35Evid135' event (evid: 135)
 *
 * Event description: When the user clicked on one of the developer tools
 *
 * @param {clickToOpenDeveloperToolSrc35Evid135Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} developerToolName - set_up_webhooks / api_keys
 * @return {LogObject<clickToOpenDeveloperToolSrc35Evid135Params>} LogObject<clickToOpenDeveloperToolSrc35Evid135Params>
 */
export function clickToOpenDeveloperToolSrc35Evid135(params) {
    return { evid: 135, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCreateWebhookSrc35Evid136' event (evid: 136)
 *
 * Event description: When the user click to create a new webhook
 *
 * @param {clickToCreateWebhookSrc35Evid136Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @return {LogObject<clickToCreateWebhookSrc35Evid136Params>} LogObject<clickToCreateWebhookSrc35Evid136Params>
 */
export function clickToCreateWebhookSrc35Evid136(params) {
    return { evid: 136, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToViewDeveloperToolDocumentationSrc35Evid137' event (evid: 137)
 *
 * Event description: When the user click to view the developer tool documentation
 *
 * @param {clickToViewDeveloperToolDocumentationSrc35Evid137Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToViewDeveloperToolDocumentationSrc35Evid137Params>} LogObject<clickToViewDeveloperToolDocumentationSrc35Evid137Params>
 */
export function clickToViewDeveloperToolDocumentationSrc35Evid137(params) {
    return { evid: 137, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToGenerateApiKeySrc35Evid138' event (evid: 138)
 *
 * Event description: When the user click to create a new API key
 *
 * @param {clickToGenerateApiKeySrc35Evid138Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToGenerateApiKeySrc35Evid138Params>} LogObject<clickToGenerateApiKeySrc35Evid138Params>
 */
export function clickToGenerateApiKeySrc35Evid138(params) {
    return { evid: 138, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToViewDeveloperToolAccountIdSrc35Evid139' event (evid: 139)
 *
 * Event description: When the user click to view the developer tool account ID
 *
 * @param {clickToViewDeveloperToolAccountIdSrc35Evid139Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToViewDeveloperToolAccountIdSrc35Evid139Params>} LogObject<clickToViewDeveloperToolAccountIdSrc35Evid139Params>
 */
export function clickToViewDeveloperToolAccountIdSrc35Evid139(params) {
    return { evid: 139, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChooseExpirationType' event (evid: 14)
 *
 * Event description: When the user click to choose one of the expiration types
 *
 * @param {clickToChooseExpirationTypeParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {string} pageName - The page name where the action was created at
 * @property {string} type - never / time_period / specific_date
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @return {LogObject<clickToChooseExpirationTypeParams>} LogObject<clickToChooseExpirationTypeParams>
 */
export function clickToChooseExpirationType(params) {
    return { evid: 14, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToViewDeveloperToolPublicKeysSrc35Evid140' event (evid: 140)
 *
 * Event description: When the user click to view the developer tool Public Keys
 *
 * @param {clickToViewDeveloperToolPublicKeysSrc35Evid140Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToViewDeveloperToolPublicKeysSrc35Evid140Params>} LogObject<clickToViewDeveloperToolPublicKeysSrc35Evid140Params>
 */
export function clickToViewDeveloperToolPublicKeysSrc35Evid140(params) {
    return { evid: 140, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenIssueGiftCardModal' event (evid: 1404)
 *
 * Event description: when the user clicked to open modal of Issue GC from one of the entry points
 *
 * @param {clickToOpenIssueGiftCardModalParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - main button / etc
 * @return {LogObject<clickToOpenIssueGiftCardModalParams>} LogObject<clickToOpenIssueGiftCardModalParams>
 */
export function clickToOpenIssueGiftCardModal(params) {
    return { evid: 1404, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'issueGiftCardModalOpened' event (evid: 1405)
 *
 * Event description: When the Issue gift card modal opened
 *
 * @param {issueGiftCardModalOpenedParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - main button / etc
 * @return {LogObject<issueGiftCardModalOpenedParams>} LogObject<issueGiftCardModalOpenedParams>
 */
export function issueGiftCardModalOpened(params) {
    return { evid: 1405, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckedUncheckedSendAnEmailToTheRecipient' event (evid: 1406)
 *
 * Event description: When the user check / uncheck the checkbox of "Send an email to the recipient"
 *
 * @param {clickToCheckedUncheckedSendAnEmailToTheRecipientParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {boolean} isChecked - TRUE / FALSE
 * @return {LogObject<clickToCheckedUncheckedSendAnEmailToTheRecipientParams>} LogObject<clickToCheckedUncheckedSendAnEmailToTheRecipientParams>
 */
export function clickToCheckedUncheckedSendAnEmailToTheRecipient(params) {
    return { evid: 1406, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckedUncheckedAddSenderDetails' event (evid: 1407)
 *
 * Event description: When the user check / uncheck the checkbox of "Add sender details" in issue gift card modal
 *
 * @param {clickToCheckedUncheckedAddSenderDetailsParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {boolean} isChecked - TRUE / FALSE
 * @return {LogObject<clickToCheckedUncheckedAddSenderDetailsParams>} LogObject<clickToCheckedUncheckedAddSenderDetailsParams>
 */
export function clickToCheckedUncheckedAddSenderDetails(params) {
    return { evid: 1407, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToIssueGiftCard' event (evid: 1408)
 *
 * Event description: When the user clicked on the "issue gift card" button, when the form is valid.
 *
 * @param {clickToIssueGiftCardParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {number} amount - The GC value which was issued
 * @property {string} dateExpirationType - certain period / specific date / null
 * @property {string} timePeriodType - year / day / null
 * @property {number} timePeriodValue - number of days / years the user choose / null
 * @property {DateTime} expirationDate - the chosen expiration date / null
 * @property {boolean} isNotifyRecipientEmail - TRUE / FALSE
 * @property {boolean} isSenderDetailsAdded - TRUE / FALSE
 * @return {LogObject<clickToIssueGiftCardParams>} LogObject<clickToIssueGiftCardParams>
 */
export function clickToIssueGiftCard(params) {
    return { evid: 1408, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToResendGiftCardByEmail' event (evid: 1409)
 *
 * Event description: When the user click to resend gift card email to recipient
 *
 * @param {clickToResendGiftCardByEmailParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - main button / etc
 * @property {GUID} giftCardId - the GC ID which email was sent for
 * @return {LogObject<clickToResendGiftCardByEmailParams>} LogObject<clickToResendGiftCardByEmailParams>
 */
export function clickToResendGiftCardByEmail(params) {
    return { evid: 1409, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToRemoveAppIntegrationSrc35Evid141' event (evid: 141)
 *
 * Event description: When the user click to remove the integration to the app
 *
 * @param {clickToRemoveAppIntegrationSrc35Evid141Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} appName - the app name related to the action
 * @return {LogObject<clickToRemoveAppIntegrationSrc35Evid141Params>} LogObject<clickToRemoveAppIntegrationSrc35Evid141Params>
 */
export function clickToRemoveAppIntegrationSrc35Evid141(params) {
    return { evid: 141, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenDisableGiftCardModal' event (evid: 1410)
 *
 * Event description: When the user click to open the "Disable gift card" modal through one of the entry points
 *
 * @param {clickToOpenDisableGiftCardModalParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - main button / etc
 * @property {GUID} giftCardId - the related GC ID
 * @return {LogObject<clickToOpenDisableGiftCardModalParams>} LogObject<clickToOpenDisableGiftCardModalParams>
 */
export function clickToOpenDisableGiftCardModal(params) {
    return { evid: 1410, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDisableGiftCard' event (evid: 1411)
 *
 * Event description: When the user click to Disable the GC in the modal
 *
 * @param {clickToDisableGiftCardParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - main button / etc
 * @property {GUID} giftCardId - the related GC ID
 * @return {LogObject<clickToDisableGiftCardParams>} LogObject<clickToDisableGiftCardParams>
 */
export function clickToDisableGiftCard(params) {
    return { evid: 1411, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenGiftCardPage' event (evid: 1412)
 *
 * Event description: When the user clicked on a gift card in the "GC List" or through another entry point which leads to the "GC page"
 *
 * @param {clickToOpenGiftCardPageParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - main button / etc
 * @property {GUID} giftCardId - the GC ID which the action relate to
 * @return {LogObject<clickToOpenGiftCardPageParams>} LogObject<clickToOpenGiftCardPageParams>
 */
export function clickToOpenGiftCardPage(params) {
    return { evid: 1412, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnMoreActionsButton' event (evid: 1413)
 *
 * Event description: When the user click on the "More Actions" button to open the list
 *
 * @param {clickOnMoreActionsButtonParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - main button / etc
 * @return {LogObject<clickOnMoreActionsButtonParams>} LogObject<clickOnMoreActionsButtonParams>
 */
export function clickOnMoreActionsButton(params) {
    return { evid: 1413, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenEditBalanceModal' event (evid: 1414)
 *
 * Event description: When the user click to open the Edit Balance modal
 *
 * @param {clickToOpenEditBalanceModalParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - icon / more-actions-list
 * @property {GUID} giftCardId - the GC ID which the action relate to
 * @return {LogObject<clickToOpenEditBalanceModalParams>} LogObject<clickToOpenEditBalanceModalParams>
 */
export function clickToOpenEditBalanceModal(params) {
    return { evid: 1414, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnSaveToEditTheGiftCardBalance' event (evid: 1415)
 *
 * Event description: When the user clicked save (without form error) for changing the GC balance
 *
 * @param {clickOnSaveToEditTheGiftCardBalanceParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - edit-gift-card-modal / etc
 * @property {GUID} giftCardId - the GC ID which the action relate to
 * @property {number} prevBalanceLong - previous balance before change, multiply by 100,000
 * @property {number} newBalanceLong - new balance after change multiply by 100,000
 * @return {LogObject<clickOnSaveToEditTheGiftCardBalanceParams>} LogObject<clickOnSaveToEditTheGiftCardBalanceParams>
 */
export function clickOnSaveToEditTheGiftCardBalance(params) {
    return { evid: 1415, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenChangeGiftCardExpirationModal' event (evid: 1416)
 *
 * Event description: When the user clicked to open the "Change Expiration modal" of the GC
 *
 * @param {clickToOpenChangeGiftCardExpirationModalParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - icon / more-actions-list
 * @property {GUID} giftCardId - the GC ID which the action relate to
 * @return {LogObject<clickToOpenChangeGiftCardExpirationModalParams>} LogObject<clickToOpenChangeGiftCardExpirationModalParams>
 */
export function clickToOpenChangeGiftCardExpirationModal(params) {
    return { evid: 1416, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChangeTheTypeExpirationOfAGiftCard' event (evid: 1417)
 *
 * Event description: When the user switched between the radio buttons in the "change expiration gift card" modal
 *
 * @param {clickToChangeTheTypeExpirationOfAGiftCardParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - icon / more-actions-list
 * @property {GUID} giftCardId - the GC ID which the action relate to
 * @property {string} type - never expires / specific date
 * @return {LogObject<clickToChangeTheTypeExpirationOfAGiftCardParams>} LogObject<clickToChangeTheTypeExpirationOfAGiftCardParams>
 */
export function clickToChangeTheTypeExpirationOfAGiftCard(params) {
    return { evid: 1417, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChangeTheExpirationOfAGiftCard' event (evid: 1418)
 *
 * Event description: When the user clicked on the "change expiration" in the change gift card expiration modal
 *
 * @param {clickToChangeTheExpirationOfAGiftCardParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - edit-gift-card-modal / etc
 * @property {GUID} giftCardId - the GC ID which the action relate to
 * @property {DateTime} prevExpirationDate - null if no expiration date, specific date if there is
 * @property {DateTime} newExpirationDate - null if no expiration date, specific date if there is
 * @property {string} type - The new expiration type: never / specific date
 * @return {LogObject<clickToChangeTheExpirationOfAGiftCardParams>} LogObject<clickToChangeTheExpirationOfAGiftCardParams>
 */
export function clickToChangeTheExpirationOfAGiftCard(params) {
    return { evid: 1418, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowPageLoaded' event (evid: 1419)
 *
 * Event description: When a page was loaded during the login / signup flow
 *
 * @param {loginSignupFlowPageLoadedParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - The source from which the user originated, i.e., Wix or Shopify.
 * @property {string} pageName - The loaded page name. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @property {number} loadingTime - TO DELETE
 * @return {LogObject<loginSignupFlowPageLoadedParams>} LogObject<loginSignupFlowPageLoadedParams>
 */
export function loginSignupFlowPageLoaded(params) {
    return { evid: 1419, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenASettingFieldPageSrc35Evid142' event (evid: 142)
 *
 * Event description: When the user clicked on one of the the setting fields in the setting page
 *
 * @param {clickToOpenASettingFieldPageSrc35Evid142Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} settingField - business-setting, team-members, billing
 * @return {LogObject<clickToOpenASettingFieldPageSrc35Evid142Params>} LogObject<clickToOpenASettingFieldPageSrc35Evid142Params>
 */
export function clickToOpenASettingFieldPageSrc35Evid142(params) {
    return { evid: 142, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickOnSocialLoginButton' event (evid: 1420)
 *
 * Event description: When the user click on continue with social button button
 *
 * @param {loginSignupFlowClickOnSocialLoginButtonParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} socialNetwork - i.e google, facebook, apple...
 * @property {string} pageName - The loaded page name. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickOnSocialLoginButtonParams>} LogObject<loginSignupFlowClickOnSocialLoginButtonParams>
 */
export function loginSignupFlowClickOnSocialLoginButton(params) {
    return { evid: 1420, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickOnTheLoginButton' event (evid: 1421)
 *
 * Event description: When the user clicked on the log in button
 *
 * @param {loginSignupFlowClickOnTheLoginButtonParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {boolean} formStatus - If the clicked succeeded = TRUE
 * @property {string} formErrors - Array of the errors if appear (null if not)
 * @property {string} pageName - The origin of the page the user was at when clicked. i.e: login , signup, confirm mail page, create account page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickOnTheLoginButtonParams>} LogObject<loginSignupFlowClickOnTheLoginButtonParams>
 */
export function loginSignupFlowClickOnTheLoginButton(params) {
    return { evid: 1421, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowLoginRequestSent' event (evid: 1425)
 *
 * Event description: When a login request sent
 *
 * @param {loginSignupFlowLoginRequestSentParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID (null if the request failed)
 * @property {GUID} clientId - TO DELETE
 * @property {boolean} status - true = login succeed (Request suceeded)
 * @property {string} errorMessage - null if no error
 * @property {string} origin - The origin of the page the request was sent from. i.e: login , signup, cofirme mail page, create account page, forget password page, etc...
 * @property {string} sourceChannel - TO DELETE
 * @return {LogObject<loginSignupFlowLoginRequestSentParams>} LogObject<loginSignupFlowLoginRequestSentParams>
 */
export function loginSignupFlowLoginRequestSent(params) {
    return { evid: 1425, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowSignupRequestSent' event (evid: 1426)
 *
 * Event description: When a signup request sent
 *
 * @param {loginSignupFlowSignupRequestSentParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID (null if the request failed)
 * @property {GUID} clientId - TO DELETE
 * @property {boolean} status - true = signup succeed (Request succeeded)
 * @property {string} errorMessage - null if no error
 * @property {string} origin - The origin of the page the request was sent from. i.e: login , signup, cofirme mail page, create account page, forget password page, etc...
 * @property {string} sourceChannel - TO DELETE
 * @return {LogObject<loginSignupFlowSignupRequestSentParams>} LogObject<loginSignupFlowSignupRequestSentParams>
 */
export function loginSignupFlowSignupRequestSent(params) {
    return { evid: 1426, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'testServerEvent' event (evid: 1427)
 *
 * Event description: Test server event
 *
 * @param {testServerEventParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID (null if the request failed)
 * @property {GUID} clientId - TO DELETE
 * @property {boolean} status - true = succeed
 * @property {string} errorMessage - null if no error
 * @property {string} origin - The origin of the page the request was sent from. i.e: login , signup, cofirme mail page, create account page, forget password page, etc...
 * @property {string} sourceChannel - TO DELETE
 * @return {LogObject<testServerEventParams>} LogObject<testServerEventParams>
 */
export function testServerEvent(params) {
    return { evid: 1427, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowNewRiseAiUserWasCreated' event (evid: 1428)
 *
 * Event description: When a new user was created
 *
 * @param {loginSignupFlowNewRiseAiUserWasCreatedParams} params - The parameters for this event
 * @property {GUID} clientId - client id
 * @property {string} origin - The origin of the user creation: social sign up, signup flow internal, ...
 * @property {GUID} uuid - The new created Wix User for the related account. (An account hasn't been created yet)
 * @return {LogObject<loginSignupFlowNewRiseAiUserWasCreatedParams>} LogObject<loginSignupFlowNewRiseAiUserWasCreatedParams>
 */
export function loginSignupFlowNewRiseAiUserWasCreated(params) {
    return { evid: 1428, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowNewRiseAiAccountWasCreated' event (evid: 1429)
 *
 * Event description: When a new Rise Account was created
 *
 * @param {loginSignupFlowNewRiseAiAccountWasCreatedParams} params - The parameters for this event
 * @property {GUID} clientId - client ID
 * @property {string} origin - The origin of the user creation: social button, signup flow internal, ...
 * @property {string} utm_source - Paid Marketing	-google, facebook, etc.
 * @property {string} utm_medium - Paid Marketing	- organic, cpc, paid, etc.
 * @property {string} utm_campaign - Paid Marketing	-campaign name
 * @property {string} utm_id - Paid Marketing	-campaign id
 * @property {string} utm_term - Paid Marketing	-search keyword
 * @property {string} utm_content - Paid Marketing	-ad name / copy
 * @property {string} surface_type - Shopify Ads-home, search, search_ad, categoty, etc
 * @property {string} surface_detail - Shopify Ads-search keyword, category, etc.
 * @property {string} locale - Shopify Ads-GEO location
 * @property {string} surface_inter_position - Shopify Ads-
 * @property {string} surface_intra_position - Shopify Ads-
 * @property {string} source_platform - square, shopify, wix...
 * @property {GUID} msid - Then newRise Account ID which was created
 * @property {GUID} uuid - The new user ID which was related to the Account Creation
 * @return {LogObject<loginSignupFlowNewRiseAiAccountWasCreatedParams>} LogObject<loginSignupFlowNewRiseAiAccountWasCreatedParams>
 */
export function loginSignupFlowNewRiseAiAccountWasCreated(params) {
    return { evid: 1429, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnInviteNewMemberInPermissionsSettingSrc35Evid143' event (evid: 143)
 *
 * Event description: When the user clicked on one of the the setting fields in the setting page
 *
 * @param {clickOnInviteNewMemberInPermissionsSettingSrc35Evid143Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnInviteNewMemberInPermissionsSettingSrc35Evid143Params>} LogObject<clickOnInviteNewMemberInPermissionsSettingSrc35Evid143Params>
 */
export function clickOnInviteNewMemberInPermissionsSettingSrc35Evid143(params) {
    return { evid: 143, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowSocialLoginSignupAuthSucceedFailed' event (evid: 1430)
 *
 * Event description: event is generated when social authentication succeed or failed
 *
 * @param {loginSignupFlowSocialLoginSignupAuthSucceedFailedParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {boolean} status - true = authorization succeeded
 * @property {string} errorMessage - null if no error
 * @property {string} origin - The origin of the page the request was sent from. i.e: login , signup, cofirme mail page, create account page, forget password page, etc...
 * @property {string} sourceChannel - TO DELETE
 * @return {LogObject<loginSignupFlowSocialLoginSignupAuthSucceedFailedParams>} LogObject<loginSignupFlowSocialLoginSignupAuthSucceedFailedParams>
 */
export function loginSignupFlowSocialLoginSignupAuthSucceedFailed(params) {
    return { evid: 1430, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowEmailWasSent' event (evid: 1431)
 *
 * Event description: When an email was sent to the user
 *
 * @param {loginSignupFlowEmailWasSentParams} params - The parameters for this event
 * @property {GUID} clientId - Unique client id ( Anonymous at Wix)
 * @property {boolean} status - true = email was sent
 * @property {string} errorMessage - null if no error
 * @property {string} origin - The origin of the page the request was sent from. i.e: login , signup, cofirme mail page, create account page, forget password page, etc...
 * @property {string} emailType - The type of the sent email. i.e: email varification , reset password, etc...
 * @return {LogObject<loginSignupFlowEmailWasSentParams>} LogObject<loginSignupFlowEmailWasSentParams>
 */
export function loginSignupFlowEmailWasSent(params) {
    return { evid: 1431, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowLogOutRequestSent' event (evid: 1432)
 *
 * Event description: When a log out request was sent
 *
 * @param {loginSignupFlowLogOutRequestSentParams} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {GUID} clientId - TO DELETE
 * @property {boolean} status - true = logout succeed
 * @property {string} sourceChannel - TO DELETE
 * @property {string} errorMessage - null if no error
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<loginSignupFlowLogOutRequestSentParams>} LogObject<loginSignupFlowLogOutRequestSentParams>
 */
export function loginSignupFlowLogOutRequestSent(params) {
    return { evid: 1432, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowResetPasswordRequestWasSent' event (evid: 1433)
 *
 * Event description: When a changing password request was sent
 *
 * @param {loginSignupFlowResetPasswordRequestWasSentParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {boolean} status - true = request succeeded
 * @property {string} sourceChannel - TO DELETE
 * @property {string} errorMessage - null if no error
 * @property {string} origin - TO DELETE
 * @return {LogObject<loginSignupFlowResetPasswordRequestWasSentParams>} LogObject<loginSignupFlowResetPasswordRequestWasSentParams>
 */
export function loginSignupFlowResetPasswordRequestWasSent(params) {
    return { evid: 1433, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedRememberMeCheckbox' event (evid: 1434)
 *
 * Event description: When the user clicked on remember me checkbox
 *
 * @param {loginSignupFlowClickedRememberMeCheckboxParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @property {boolean} isChecked - TRUE / FALSE
 * @return {LogObject<loginSignupFlowClickedRememberMeCheckboxParams>} LogObject<loginSignupFlowClickedRememberMeCheckboxParams>
 */
export function loginSignupFlowClickedRememberMeCheckbox(params) {
    return { evid: 1434, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnSwitchFormToSignupOrLogin' event (evid: 1435)
 *
 * Event description: When the user switched form sign up / log in
 *
 * @param {loginSignupFlowClickedOnSwitchFormToSignupOrLoginParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @property {string} switchTo - What button the user clicked (switch to - login\signup)?
 * @return {LogObject<loginSignupFlowClickedOnSwitchFormToSignupOrLoginParams>} LogObject<loginSignupFlowClickedOnSwitchFormToSignupOrLoginParams>
 */
export function loginSignupFlowClickedOnSwitchFormToSignupOrLogin(params) {
    return { evid: 1435, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnForgotPassword' event (evid: 1436)
 *
 * Event description: When the user clicked on the forgot password
 *
 * @param {loginSignupFlowClickedOnForgotPasswordParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickedOnForgotPasswordParams>} LogObject<loginSignupFlowClickedOnForgotPasswordParams>
 */
export function loginSignupFlowClickedOnForgotPassword(params) {
    return { evid: 1436, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnSendResetCodeButton' event (evid: 1437)
 *
 * Event description: When the user clicked on the "send reset code" button
 *
 * @param {loginSignupFlowClickedOnSendResetCodeButtonParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickedOnSendResetCodeButtonParams>} LogObject<loginSignupFlowClickedOnSendResetCodeButtonParams>
 */
export function loginSignupFlowClickedOnSendResetCodeButton(params) {
    return { evid: 1437, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnBackButton' event (evid: 1438)
 *
 * Event description: When the user clicked on the "send reset code" button
 *
 * @param {loginSignupFlowClickedOnBackButtonParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @property {string} destinationPage - The page the user will be back to
 * @return {LogObject<loginSignupFlowClickedOnBackButtonParams>} LogObject<loginSignupFlowClickedOnBackButtonParams>
 */
export function loginSignupFlowClickedOnBackButton(params) {
    return { evid: 1438, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnResetPasswordButton' event (evid: 1439)
 *
 * Event description: When the user clicked on the button tot reset the code
 *
 * @param {loginSignupFlowClickedOnResetPasswordButtonParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickedOnResetPasswordButtonParams>} LogObject<loginSignupFlowClickedOnResetPasswordButtonParams>
 */
export function loginSignupFlowClickedOnResetPasswordButton(params) {
    return { evid: 1439, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSaveBusinessSettingChangesSrc35Evid144' event (evid: 144)
 *
 * Event description: When the user Click to save business setting changes
 *
 * @param {clickToSaveBusinessSettingChangesSrc35Evid144Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} businessName - the saved business name
 * @property {string} businessEmail - the saved business email
 * @property {string} Industry - the saved industry value
 * @property {string} otherIndustryName - if the industry is other, then the name
 * @property {string} currency - the saved currency
 * @property {string} language - the saved language
 * @return {LogObject<clickToSaveBusinessSettingChangesSrc35Evid144Params>} LogObject<clickToSaveBusinessSettingChangesSrc35Evid144Params>
 */
export function clickToSaveBusinessSettingChangesSrc35Evid144(params) {
    return { evid: 144, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnResendCode' event (evid: 1440)
 *
 * Event description: When the user clicked on resend code , to resend the code to the email
 *
 * @param {loginSignupFlowClickedOnResendCodeParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickedOnResendCodeParams>} LogObject<loginSignupFlowClickedOnResendCodeParams>
 */
export function loginSignupFlowClickedOnResendCode(params) {
    return { evid: 1440, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnChangePasswordButton' event (evid: 1441)
 *
 * Event description: When the use clicked to change the password
 *
 * @param {loginSignupFlowClickedOnChangePasswordButtonParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickedOnChangePasswordButtonParams>} LogObject<loginSignupFlowClickedOnChangePasswordButtonParams>
 */
export function loginSignupFlowClickedOnChangePasswordButton(params) {
    return { evid: 1441, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnSignupButton' event (evid: 1442)
 *
 * Event description: When the user clicked on the signup button to signup
 *
 * @param {loginSignupFlowClickedOnSignupButtonParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @property {boolean} formStatus - If the clicked succeeded = TRUE
 * @property {string} formErrors - Array of the errors if appear (null if not)
 * @return {LogObject<loginSignupFlowClickedOnSignupButtonParams>} LogObject<loginSignupFlowClickedOnSignupButtonParams>
 */
export function loginSignupFlowClickedOnSignupButton(params) {
    return { evid: 1442, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnContinueInSignupEmailVerificationPage' event (evid: 1443)
 *
 * Event description: When the use clicked to continue after inserting the verification code for signup
 *
 * @param {loginSignupFlowClickedOnContinueInSignupEmailVerificationPageParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickedOnContinueInSignupEmailVerificationPageParams>} LogObject<loginSignupFlowClickedOnContinueInSignupEmailVerificationPageParams>
 */
export function loginSignupFlowClickedOnContinueInSignupEmailVerificationPage(params) {
    return { evid: 1443, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'loginSignupFlowClickedOnResendEmail' event (evid: 1444)
 *
 * Event description: When the user clicked on resend email varfication
 *
 * @param {loginSignupFlowClickedOnResendEmailParams} params - The parameters for this event
 * @property {GUID} clientId - TO DELETE
 * @property {string} sourceChannel - TO DELETE
 * @property {string} pageName - The page name where the action happened on. i.e: login , signup, cofirme mail page, create account page, can't login page, forget password page, etc...
 * @return {LogObject<loginSignupFlowClickedOnResendEmailParams>} LogObject<loginSignupFlowClickedOnResendEmailParams>
 */
export function loginSignupFlowClickedOnResendEmail(params) {
    return { evid: 1444, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'supportPopUpWasLoadedInIntegrationPageSrc35Evid145' event (evid: 145)
 *
 * Event description: When the user clicked on the application and the support pop-up loaded instead of the application.
 *
 * @param {supportPopUpWasLoadedInIntegrationPageSrc35Evid145Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} appName - The app that is in the integration process
 * @return {LogObject<supportPopUpWasLoadedInIntegrationPageSrc35Evid145Params>} LogObject<supportPopUpWasLoadedInIntegrationPageSrc35Evid145Params>
 */
export function supportPopUpWasLoadedInIntegrationPageSrc35Evid145(params) {
    return { evid: 145, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGoToNotificationsInWalletPassPageSrc35Evid146' event (evid: 146)
 *
 * Event description: When the user clicks to go to notifications button in the wallet pass wallet pass success modal
 *
 * @param {clickOnGoToNotificationsInWalletPassPageSrc35Evid146Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnGoToNotificationsInWalletPassPageSrc35Evid146Params>} LogObject<clickOnGoToNotificationsInWalletPassPageSrc35Evid146Params>
 */
export function clickOnGoToNotificationsInWalletPassPageSrc35Evid146(params) {
    return { evid: 146, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid147' event (evid: 147)
 *
 * Event description: When the user click to add another price to the GC amounts in the gift card editor page
 *
 * @param {clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid147Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - From main page or from advanced editor for gift card variants
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid147Params>} LogObject<clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid147Params>
 */
export function clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid147(params) {
    return { evid: 147, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid148' event (evid: 148)
 *
 * Event description: When the user choose expiration type of the Gift Cards in editor page
 *
 * @param {clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid148Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} type - never / time_period
 * @property {string} sourceTenantId - The shop associated with the action
 *
 * @return {LogObject<clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid148Params>} LogObject<clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid148Params>
 */
export function clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid148(params) {
    return { evid: 148, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenPreviewCustomizeAssetsCopySrc35Evid149' event (evid: 149)
 *
 * Event description: When the user clicked to customize & preview one of the assets store credit / gift cards
 *
 * @param {clickToOpenPreviewCustomizeAssetsCopySrc35Evid149Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} assetName - The name of the asset which was clicked
 * @property {string} sourceTenantId - The shop associated with the action
 *
 * @return {LogObject<clickToOpenPreviewCustomizeAssetsCopySrc35Evid149Params>} LogObject<clickToOpenPreviewCustomizeAssetsCopySrc35Evid149Params>
 */
export function clickToOpenPreviewCustomizeAssetsCopySrc35Evid149(params) {
    return { evid: 149, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckedUncheckedNotifyCustomerByEmail' event (evid: 15)
 *
 * Event description: When the user check / uncheck the checkbox of "Notify customer by email"
 *
 * @param {clickToCheckedUncheckedNotifyCustomerByEmailParams} params - The parameters for this event
 * @property {boolean} isChecked - TRUE / FALSE
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {string} pageName - The page name where the action was created at
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @return {LogObject<clickToCheckedUncheckedNotifyCustomerByEmailParams>} LogObject<clickToCheckedUncheckedNotifyCustomerByEmailParams>
 */
export function clickToCheckedUncheckedNotifyCustomerByEmail(params) {
    return { evid: 15, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToEditColorInWalletPassSrc35Evid150' event (evid: 150)
 *
 * Event description: when a user clicks to edit the colors of background or title in wallet pass page
 *
 * @param {clickToEditColorInWalletPassSrc35Evid150Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} type - Background / Title
 * @return {LogObject<clickToEditColorInWalletPassSrc35Evid150Params>} LogObject<clickToEditColorInWalletPassSrc35Evid150Params>
 */
export function clickToEditColorInWalletPassSrc35Evid150(params) {
    return { evid: 150, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingFunnelFinishAndRedirectToDashboardSrc35Evid151' event (evid: 151)
 *
 * Event description: When the user finish the onboarding funnel and redirect to dashboard
 *
 * @param {onboardingFunnelFinishAndRedirectToDashboardSrc35Evid151Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} lastStepId - The ID of the last  step page
 * @return {LogObject<onboardingFunnelFinishAndRedirectToDashboardSrc35Evid151Params>} LogObject<onboardingFunnelFinishAndRedirectToDashboardSrc35Evid151Params>
 */
export function onboardingFunnelFinishAndRedirectToDashboardSrc35Evid151(params) {
    return { evid: 151, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckUncheckUpdateInventorySrc35Evid152' event (evid: 152)
 *
 * Event description: When the user check / uncheck the checkbox of "Update Inventory"
 *
 * @param {clickToCheckUncheckUpdateInventorySrc35Evid152Params} params - The parameters for this event
 * @property {boolean} isChecked - TRUE / FALSE
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {string} pageName - The page name where the action was created at
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @return {LogObject<clickToCheckUncheckUpdateInventorySrc35Evid152Params>} LogObject<clickToCheckUncheckUpdateInventorySrc35Evid152Params>
 */
export function clickToCheckUncheckUpdateInventorySrc35Evid152(params) {
    return { evid: 152, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingFunnelStepPageViewSrc35Evid153' event (evid: 153)
 *
 * Event description: When the user view step page in rise onboarding funnel
 *
 * @param {onboardingFunnelStepPageViewSrc35Evid153Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} currentStep - The BI slug from Wix flows. Identify the name of the current step
 * @property {string} currentStepId - The ID of the current step page
 * @property {string} previousStepId - The ID of the previous step page
 * @property {string} question - the question that is presented to the user
 * @property {string} optionalAnswers - the optional answers  that are presented to the user
 * @property {string} previousStep - The BI slug from Wix flows. Identify the name of the
 * previous step
 * @return {LogObject<onboardingFunnelStepPageViewSrc35Evid153Params>} LogObject<onboardingFunnelStepPageViewSrc35Evid153Params>
 */
export function onboardingFunnelStepPageViewSrc35Evid153(params) {
    return { evid: 153, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckUncheckLineItemSrc35Evid154' event (evid: 154)
 *
 * Event description: When the user check / uncheck the checkbox of "Line item"
 *
 * @param {clickToCheckUncheckLineItemSrc35Evid154Params} params - The parameters for this event
 * @property {boolean} isChecked - TRUE / FALSE
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {string} pageName - The page name where the action was created at
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @property {string} catalogItemId - In Rise app on Wix you can issue store credit from ecom order page, so this is the catalog item id.
 * @return {LogObject<clickToCheckUncheckLineItemSrc35Evid154Params>} LogObject<clickToCheckUncheckLineItemSrc35Evid154Params>
 */
export function clickToCheckUncheckLineItemSrc35Evid154(params) {
    return { evid: 154, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCheckUncheckLineItemQuantitySrc35Evid155' event (evid: 155)
 *
 * Event description: When the user check / uncheck the checkbox of "Line item quantity"
 *
 * @param {clickToCheckUncheckLineItemQuantitySrc35Evid155Params} params - The parameters for this event
 * @property {boolean} isIncrease - In Rise app on Wix you can issue store credit from ecom order page-
 * TRUE for increase quantity, FALSE for decrease quantity.
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {string} pageName - The page name where the action was created at
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @property {string} catalogItemId - In Rise app on Wix you can issue store credit from ecom order page, so this is the catalog item id.
 * @property {number} newAmount - In Rise app on Wix you can issue store credit from ecom order page- new quantity (how many items are being returned?)
 * @property {number} oldAmount - In Rise app on Wix you can issue store credit from ecom order page- old quantity (how many items were in the order initially?)
 * @return {LogObject<clickToCheckUncheckLineItemQuantitySrc35Evid155Params>} LogObject<clickToCheckUncheckLineItemQuantitySrc35Evid155Params>
 */
export function clickToCheckUncheckLineItemQuantitySrc35Evid155(params) {
    return { evid: 155, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToIssueStoreCredit' event (evid: 16)
 *
 * Event description: When the user clicked on the "issue store credit" button, when the form is valid. Sent regardless if there was an exist wallet
 *
 * @param {clickToIssueStoreCreditParams} params - The parameters for this event
 * @property {DateTime} expirationDate - the chosen expiration date when it's specific / null
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {boolean} isNotifyCustomerEmail - TRUE / FALSE
 * @property {GUID} walletId - The wallet id which the Issue store credit is relate to. null if not exist
 * @property {string} dateExpirationType - certain period / specific date / null
 * @property {number} amount - The store credit value which was issued
 * @property {number} timePeriodValue - number of days / years the user choose / null
 * @property {string} origin - issue gift card modal / issue store credit modal / etc...
 * @property {GUID} contactId - contactId who received the stores credit (WixContactId). null if not exist
 * @property {string} pageName - The page name where the action was created at
 * @property {string} timePeriodType - year / day / null
 * @property {string} internalNote - The internal note which was added / null
 * @property {number} amountLong - amount long
 * @property {boolean} isUpdateInventory - In Rise app on Wix you can issue store credit from ecom order page, update inventory- true, not update inventory - false.
 * @property {number} numLineItems - In Rise app on Wix you can issue store credit from ecom order page, this is the number of line items checked
 * @property {string} lineItems - In Rise app on Wix you can issue store credit from ecom order page- line items details (catalog item id, quantity)
 * @property {string} orderId - In Rise app on Wix you can issue store credit from ecom order page, so this is the order id.
 * @return {LogObject<clickToIssueStoreCreditParams>} LogObject<clickToIssueStoreCreditParams>
 */
export function clickToIssueStoreCredit(params) {
    return { evid: 16, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createWalletModalOpened' event (evid: 17)
 *
 * Event description: When the create wallet modal opened
 *
 * @param {createWalletModalOpenedParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - store credit modal / wallet modal
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<createWalletModalOpenedParams>} LogObject<createWalletModalOpenedParams>
 */
export function createWalletModalOpened(params) {
    return { evid: 17, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCreateWallet' event (evid: 18)
 *
 * Event description: When the user create a new wallet through the modal
 *
 * @param {clickToCreateWalletParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - store credit modal / wallet modal
 * @property {string} pageName - The page name where the action was created at
 * @property {number} initialValueLong - the initial value the wallet was created with
 * @return {LogObject<clickToCreateWalletParams>} LogObject<clickToCreateWalletParams>
 */
export function clickToCreateWallet(params) {
    return { evid: 18, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnCopyCode' event (evid: 19)
 *
 * Event description: When the user clicked to copy code of GC / SC
 *
 * @param {clickOnCopyCodeParams} params - The parameters for this event
 * @property {GUID} giftCardId - null if not exist
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {GUID} walletId - null if not gift card
 * @property {string} origin - icon / etc
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnCopyCodeParams>} LogObject<clickOnCopyCodeParams>
 */
export function clickOnCopyCode(params) {
    return { evid: 19, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenTheEditGiftCardPageSrc35Evid2' event (evid: 2)
 *
 * Event description: When the user clicked to open  the edit gift card page
 *
 * @param {clickToOpenTheEditGiftCardPageSrc35Evid2Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToOpenTheEditGiftCardPageSrc35Evid2Params>} LogObject<clickToOpenTheEditGiftCardPageSrc35Evid2Params>
 */
export function clickToOpenTheEditGiftCardPageSrc35Evid2(params) {
    return { evid: 2, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToShowTransactionDetails' event (evid: 20)
 *
 * Event description: Clicked on a specific transaction in the wallet-page transaction table
 *
 * @param {clickToShowTransactionDetailsParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} transactionType - The type of the clicked transaction
 * @property {string} origin - cairo / etc
 * @property {string} pageName - The page name where the action was created at
 * @property {GUID} transactionId - the ID of the clicked transaction
 * @return {LogObject<clickToShowTransactionDetailsParams>} LogObject<clickToShowTransactionDetailsParams>
 */
export function clickToShowTransactionDetails(params) {
    return { evid: 20, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixPluginLoadedSrc35Evid200' event (evid: 200)
 *
 * Event description: When Rise on Wix plug in is loaded
 * currently there is only the quick apply plug-in in a checkout slot
 *
 * @param {riseWixPluginLoadedSrc35Evid200Params} params - The parameters for this event
 * @property {GUID} visitor_id - Wix visitor id
 * @property {string} appName - plug-in name
 * @property {number} balance - Wallet balance when the plugin is loaded (if there is no balance return 0) multiply by 100000
 * @property {string} pluginId - pluginId
 * @return {LogObject<riseWixPluginLoadedSrc35Evid200Params>} LogObject<riseWixPluginLoadedSrc35Evid200Params>
 */
export function riseWixPluginLoadedSrc35Evid200(params) {
    return { evid: 200, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixPluginClickSrc35Evid201' event (evid: 201)
 *
 * Event description: When a visitor clicks on Rise on Wix plug in.
 * currently there is only the quick apply plug-in in a checkout slot
 *
 * @param {riseWixPluginClickSrc35Evid201Params} params - The parameters for this event
 * @property {GUID} visitor_id - Wix visitor id
 * @property {string} appName - plug-in name
 * @property {number} balance - Wallet balance when the visitor clicks on the plugin (if there is no balance return 0) multiply by 100000
 * @property {string} buttonName - quick apply: "expand / collapse", "apply"
 * @property {string} state - quick apply: disabled (when visitor clicks to open store credit after redeem)
 * @property {string} errorName - the error message that shown when the click happens
 * @property {string} pluginId - pluginId
 * @return {LogObject<riseWixPluginClickSrc35Evid201Params>} LogObject<riseWixPluginClickSrc35Evid201Params>
 */
export function riseWixPluginClickSrc35Evid201(params) {
    return { evid: 201, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixPluginErrorShownSrc35Evid202' event (evid: 202)
 *
 * Event description: When an error is shown on Rise on Wix plug-in
 * currently there is only the quick apply plug-in in checkout slots
 *
 * @param {riseWixPluginErrorShownSrc35Evid202Params} params - The parameters for this event
 * @property {GUID} visitor_id - Wix visitor id
 * @property {string} appName - plug-in name
 * @property {string} errorName - Error type
 * @property {string} pluginId - plug-in id
 * @return {LogObject<riseWixPluginErrorShownSrc35Evid202Params>} LogObject<riseWixPluginErrorShownSrc35Evid202Params>
 */
export function riseWixPluginErrorShownSrc35Evid202(params) {
    return { evid: 202, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixPluginLoadingInitiatedSrc35Evid203' event (evid: 203)
 *
 * Event description: When Rise on Wix plug in started to load
 * currently there is only the quick apply plug-in in a checkout slot
 *
 * @param {riseWixPluginLoadingInitiatedSrc35Evid203Params} params - The parameters for this event
 * @property {GUID} visitor_id - Wix visitor id
 * @property {string} appName - plug-in app name
 * @property {string} pluginId - pluginId
 * @return {LogObject<riseWixPluginLoadingInitiatedSrc35Evid203Params>} LogObject<riseWixPluginLoadingInitiatedSrc35Evid203Params>
 */
export function riseWixPluginLoadingInitiatedSrc35Evid203(params) {
    return { evid: 203, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixPopulateSlotBannerIsShownSrc35Evid204' event (evid: 204)
 *
 * Event description: When the populate slot banner is shown in Rise on Wix app
 *
 * @param {riseWixPopulateSlotBannerIsShownSrc35Evid204Params} params - The parameters for this event
 * @return {LogObject<riseWixPopulateSlotBannerIsShownSrc35Evid204Params>} LogObject<riseWixPopulateSlotBannerIsShownSrc35Evid204Params>
 */
export function riseWixPopulateSlotBannerIsShownSrc35Evid204(params) {
    return { evid: 204, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixClickToPopulateSlotInBannerSrc35Evid205' event (evid: 205)
 *
 * Event description: When the users clicks to populate slot in the banner is shown in Rise on Wix app
 *
 * @param {riseWixClickToPopulateSlotInBannerSrc35Evid205Params} params - The parameters for this event
 * @return {LogObject<riseWixClickToPopulateSlotInBannerSrc35Evid205Params>} LogObject<riseWixClickToPopulateSlotInBannerSrc35Evid205Params>
 */
export function riseWixClickToPopulateSlotInBannerSrc35Evid205(params) {
    return { evid: 205, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixIssueStoreCreditSuccessFailBannerIsShownSrc35Evid206' event (evid: 206)
 *
 * Event description: When the response banner of issue store credit is shown. it can be success banner or fail banner
 *
 * @param {riseWixIssueStoreCreditSuccessFailBannerIsShownSrc35Evid206Params} params - The parameters for this event
 * @property {boolean} isSuccessful - indicates if this is success modal or failed modal
 * @property {string} orderId - when the store credit was issued from the order page it cantains the order id
 * @return {LogObject<riseWixIssueStoreCreditSuccessFailBannerIsShownSrc35Evid206Params>} LogObject<riseWixIssueStoreCreditSuccessFailBannerIsShownSrc35Evid206Params>
 */
export function riseWixIssueStoreCreditSuccessFailBannerIsShownSrc35Evid206(params) {
    return { evid: 206, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixClickOnGoToRiseAiInIssueStoreCreditSuccessBannerSrc35Evid207' event (evid: 207)
 *
 * Event description: Rise on Wix: Click on 'Go to Rise.ai' in Issue store credit success banner
 *
 * @param {riseWixClickOnGoToRiseAiInIssueStoreCreditSuccessBannerSrc35Evid207Params} params - The parameters for this event
 * @property {string} orderId - when the store credit was issued from the order page it cantains the order id
 * @return {LogObject<riseWixClickOnGoToRiseAiInIssueStoreCreditSuccessBannerSrc35Evid207Params>} LogObject<riseWixClickOnGoToRiseAiInIssueStoreCreditSuccessBannerSrc35Evid207Params>
 */
export function riseWixClickOnGoToRiseAiInIssueStoreCreditSuccessBannerSrc35Evid207(params) {
    return { evid: 207, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOn3DotsButton' event (evid: 21)
 *
 * Event description: When the user clicked to open the action list from the "3 dots" icon
 *
 * @param {clickOn3DotsButtonParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - icon / etc
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOn3DotsButtonParams>} LogObject<clickOn3DotsButtonParams>
 */
export function clickOn3DotsButton(params) {
    return { evid: 21, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenWalletPage' event (evid: 22)
 *
 * Event description: When the user clicked on a wallet in the "wallets List" or through another entry point which leads to the "wallet page"
 *
 * @param {clickToOpenWalletPageParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - cairo / etc
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickToOpenWalletPageParams>} LogObject<clickToOpenWalletPageParams>
 */
export function clickToOpenWalletPage(params) {
    return { evid: 22, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToIssueNewBatchTypeFlowSrc35Evid23' event (evid: 23)
 *
 * Event description: When the user clicked to choose new batch type (origin indicates if it's first flow)
 *
 * @param {clickToIssueNewBatchTypeFlowSrc35Evid23Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} batchType - The name of the selected batch type
 * @property {string} origin - When the origin is the main page, it's the first experience flow. else it's through the pop-up window
 * @return {LogObject<clickToIssueNewBatchTypeFlowSrc35Evid23Params>} LogObject<clickToIssueNewBatchTypeFlowSrc35Evid23Params>
 */
export function clickToIssueNewBatchTypeFlowSrc35Evid23(params) {
    return { evid: 23, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnchooseSourceOfTheBatch35Evid24' event (evid: 24)
 *
 * Event description: When the user experience the first flow, where there isn't a bulk list. and he choose between store credit or gift cards
 *
 * @param {clickOnchooseSourceOfTheBatch35Evid24Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} batchType - The name of the selected batch type
 * @property {string} source - store-credit / gift-cards
 * @return {LogObject<clickOnchooseSourceOfTheBatch35Evid24Params>} LogObject<clickOnchooseSourceOfTheBatch35Evid24Params>
 */
export function clickOnchooseSourceOfTheBatch35Evid24(params) {
    return { evid: 24, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnAnActionFromThe3DotsButtonOnBatchListTableSrc35Evid25' event (evid: 25)
 *
 * Event description: When the user clicked on the 3 dots actions from the cairo table, to generate an action on a specific batch
 *
 * @param {clickOnAnActionFromThe3DotsButtonOnBatchListTableSrc35Evid25Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} action - edit / delete / contact support / stop & delete / view / export file
 * @return {LogObject<clickOnAnActionFromThe3DotsButtonOnBatchListTableSrc35Evid25Params>} LogObject<clickOnAnActionFromThe3DotsButtonOnBatchListTableSrc35Evid25Params>
 */
export function clickOnAnActionFromThe3DotsButtonOnBatchListTableSrc35Evid25(params) {
    return { evid: 25, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnIssueNewBatchButtonSrc35Evid26' event (evid: 26)
 *
 * Event description: When the user clicked on the main "issued new batch" button
 *
 * @param {clickOnIssueNewBatchButtonSrc35Evid26Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnIssueNewBatchButtonSrc35Evid26Params>} LogObject<clickOnIssueNewBatchButtonSrc35Evid26Params>
 */
export function clickOnIssueNewBatchButtonSrc35Evid26(params) {
    return { evid: 26, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChooseSourceOfTheNewBatchStoreCreditOrGiftCardsSrc35Evid27' event (evid: 27)
 *
 * Event description: When the user chose the flow of creating a new batch: gift card / store credit
 *
 * @param {clickToChooseSourceOfTheNewBatchStoreCreditOrGiftCardsSrc35Evid27Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} value - store credit / gift card
 * @return {LogObject<clickToChooseSourceOfTheNewBatchStoreCreditOrGiftCardsSrc35Evid27Params>} LogObject<clickToChooseSourceOfTheNewBatchStoreCreditOrGiftCardsSrc35Evid27Params>
 */
export function clickToChooseSourceOfTheNewBatchStoreCreditOrGiftCardsSrc35Evid27(params) {
    return { evid: 27, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChooseBatchTypeInCreatingNewBatchFlowSrc35Evid28' event (evid: 28)
 *
 * Event description: When the user clicked to choose the creation batch type
 *
 * @param {clickToChooseBatchTypeInCreatingNewBatchFlowSrc35Evid28Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} batchType - The name of the selected batch type
 * @property {string} flow - store-credit / gift-cards
 * @return {LogObject<clickToChooseBatchTypeInCreatingNewBatchFlowSrc35Evid28Params>} LogObject<clickToChooseBatchTypeInCreatingNewBatchFlowSrc35Evid28Params>
 */
export function clickToChooseBatchTypeInCreatingNewBatchFlowSrc35Evid28(params) {
    return { evid: 28, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToStartFromScratchBatchTypeInCreatingNewBatchFlowSrc35Evid29' event (evid: 29)
 *
 * Event description: When the user clicked to start from scratch the batch type instead of choose a template
 *
 * @param {clickToStartFromScratchBatchTypeInCreatingNewBatchFlowSrc35Evid29Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} flow - store-credit / gift-cards
 * @return {LogObject<clickToStartFromScratchBatchTypeInCreatingNewBatchFlowSrc35Evid29Params>} LogObject<clickToStartFromScratchBatchTypeInCreatingNewBatchFlowSrc35Evid29Params>
 */
export function clickToStartFromScratchBatchTypeInCreatingNewBatchFlowSrc35Evid29(params) {
    return { evid: 29, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToToggleOnOffGiftCardsInsteadOfOutOfStockSrc35Evid3' event (evid: 3)
 *
 * Event description: When the user Click to toggle on / off "Gift Cards instead of out of stock"
 *
 * @param {clickToToggleOnOffGiftCardsInsteadOfOutOfStockSrc35Evid3Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {boolean} isOn - true when on
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToToggleOnOffGiftCardsInsteadOfOutOfStockSrc35Evid3Params>} LogObject<clickToToggleOnOffGiftCardsInsteadOfOutOfStockSrc35Evid3Params>
 */
export function clickToToggleOnOffGiftCardsInsteadOfOutOfStockSrc35Evid3(params) {
    return { evid: 3, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickNextInCreatingNewBatchFlowSrc35Evid30' event (evid: 30)
 *
 * Event description: When the user clicked next to the next step in the creating new batch flow
 *
 * @param {clickNextInCreatingNewBatchFlowSrc35Evid30Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} step - select type / prepare / upload / details / Review & issue batch / set up
 * @property {string} batchType - The name of the selected batch type
 * @property {string} batchId - Butch id if it a edit draft flow
 * @return {LogObject<clickNextInCreatingNewBatchFlowSrc35Evid30Params>} LogObject<clickNextInCreatingNewBatchFlowSrc35Evid30Params>
 */
export function clickNextInCreatingNewBatchFlowSrc35Evid30(params) {
    return { evid: 30, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnHeaderProfileName' event (evid: 31)
 *
 * Event description: when the user clicked on the header profile name
 *
 * @param {clickOnHeaderProfileNameParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - header / etc
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnHeaderProfileNameParams>} LogObject<clickOnHeaderProfileNameParams>
 */
export function clickOnHeaderProfileName(params) {
    return { evid: 31, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnLogout' event (evid: 32)
 *
 * Event description: when the user clicked on the log out button
 *
 * @param {clickOnLogoutParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} origin - profile-name / etc..
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnLogoutParams>} LogObject<clickOnLogoutParams>
 */
export function clickOnLogout(params) {
    return { evid: 32, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickBackInCreatingNewBatchFlowSrc35Evid33' event (evid: 33)
 *
 * Event description: Click "Back" in creating new batch flow
 *
 * @param {clickBackInCreatingNewBatchFlowSrc35Evid33Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} step - prepare / upload / details / Review & issue batch / set up ...
 * @property {string} batchType - The name of the selected batch type
 * @property {string} batchId - The batch id if exists when it's edit draft flow
 * @return {LogObject<clickBackInCreatingNewBatchFlowSrc35Evid33Params>} LogObject<clickBackInCreatingNewBatchFlowSrc35Evid33Params>
 */
export function clickBackInCreatingNewBatchFlowSrc35Evid33(params) {
    return { evid: 33, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToIssueNewBatchSrc35Evid34' event (evid: 34)
 *
 * Event description: When the user finished the funnel and clicked to create the defined new batch
 *
 * @param {clickToIssueNewBatchSrc35Evid34Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} flow - store-credit / gift-cards
 * @property {string} batchType - The name of the selected batch type, if it's from scratch: from-scratch
 * @property {string} batchName - the name of the batch
 * @property {string} description - The description the user wrote.
 * @property {number} quantity - The quantity of the gc / sc in the bulk
 * @property {GUID} batchId - The id of the created batch
 * @property {boolean} isLiability - If the batch defined as liability or not
 * @return {LogObject<clickToIssueNewBatchSrc35Evid34Params>} LogObject<clickToIssueNewBatchSrc35Evid34Params>
 */
export function clickToIssueNewBatchSrc35Evid34(params) {
    return { evid: 34, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSaveNewBatchAsDraftSrc35Evid35' event (evid: 35)
 *
 * Event description: When the user finished the funnel and clicked but decided to save the batch as a draft
 *
 * @param {clickToSaveNewBatchAsDraftSrc35Evid35Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} flow - store-credit / gift-cards
 * @property {string} batchType - The name of the selected batch type, if it's from scratch: from-scratch
 * @property {string} batchName - the name of the batch
 * @property {string} revenueType - liability / non-liability
 * @property {string} description - The description the user wrote.
 * @property {number} quantity - The quantity of the gc / sc in the bulk
 * @property {GUID} batchId - The id of the saved draft bulk
 * @property {boolean} isLiability - If the batch defined as liability or not
 * @return {LogObject<clickToSaveNewBatchAsDraftSrc35Evid35Params>} LogObject<clickToSaveNewBatchAsDraftSrc35Evid35Params>
 */
export function clickToSaveNewBatchAsDraftSrc35Evid35(params) {
    return { evid: 35, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenBatchPageSrc35Evid36' event (evid: 36)
 *
 * Event description: When the user clicked on a batch in the "Batch list" or through another entry point which leads to the "Batch page"
 *
 * @param {clickToOpenBatchPageSrc35Evid36Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {GUID} batchId - The id of the batch the user clicked on
 * @return {LogObject<clickToOpenBatchPageSrc35Evid36Params>} LogObject<clickToOpenBatchPageSrc35Evid36Params>
 */
export function clickToOpenBatchPageSrc35Evid36(params) {
    return { evid: 36, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChangeViewOfTheBatchPageSrc35Evid37' event (evid: 37)
 *
 * Event description: When the user clicked to change the tab of the batch page
 *
 * @param {clickToChangeViewOfTheBatchPageSrc35Evid37Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {GUID} batchId - The id of the batch page
 * @property {string} switchedTo - Details / Gift cards / Store credits
 * @return {LogObject<clickToChangeViewOfTheBatchPageSrc35Evid37Params>} LogObject<clickToChangeViewOfTheBatchPageSrc35Evid37Params>
 */
export function clickToChangeViewOfTheBatchPageSrc35Evid37(params) {
    return { evid: 37, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenDesignCustomizeEmailTemplateSrc35Evid38' event (evid: 38)
 *
 * Event description: When the user clicked to Edit one of the email types
 *
 * @param {clickToOpenDesignCustomizeEmailTemplateSrc35Evid38Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToOpenDesignCustomizeEmailTemplateSrc35Evid38Params>} LogObject<clickToOpenDesignCustomizeEmailTemplateSrc35Evid38Params>
 */
export function clickToOpenDesignCustomizeEmailTemplateSrc35Evid38(params) {
    return { evid: 38, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenPreviewEmailTemplateSrc35Evid39' event (evid: 39)
 *
 * Event description: When the user clicked to preview one of the email types
 *
 * @param {clickToOpenPreviewEmailTemplateSrc35Evid39Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToOpenPreviewEmailTemplateSrc35Evid39Params>} LogObject<clickToOpenPreviewEmailTemplateSrc35Evid39Params>
 */
export function clickToOpenPreviewEmailTemplateSrc35Evid39(params) {
    return { evid: 39, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToUpdateMainGiftCardImageSrc35Evid4' event (evid: 4)
 *
 * Event description: When the user clicked to update the main image of the gift card
 *
 * @param {clickToUpdateMainGiftCardImageSrc35Evid4Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToUpdateMainGiftCardImageSrc35Evid4Params>} LogObject<clickToUpdateMainGiftCardImageSrc35Evid4Params>
 */
export function clickToUpdateMainGiftCardImageSrc35Evid4(params) {
    return { evid: 4, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSwitchTabOnNotificationsPageSrc35Evid40' event (evid: 40)
 *
 * Event description: When the user switch tabs on the notification page between gift_cards to store_credit
 *
 * @param {clickToSwitchTabOnNotificationsPageSrc35Evid40Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} switchedTo - The value of the clicke to swtich to gift-cards / store-credit
 * @return {LogObject<clickToSwitchTabOnNotificationsPageSrc35Evid40Params>} LogObject<clickToSwitchTabOnNotificationsPageSrc35Evid40Params>
 */
export function clickToSwitchTabOnNotificationsPageSrc35Evid40(params) {
    return { evid: 40, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToToggleEnableDisableEmailNotificationTemplateSrc35Evid41' event (evid: 41)
 *
 * Event description: When the user click on the toggle to enable / disable the email notification
 *
 * @param {clickToToggleEnableDisableEmailNotificationTemplateSrc35Evid41Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @property {GUID} templateId - The id of the template
 * @property {string} switchedTo - enable / disable
 * @return {LogObject<clickToToggleEnableDisableEmailNotificationTemplateSrc35Evid41Params>} LogObject<clickToToggleEnableDisableEmailNotificationTemplateSrc35Evid41Params>
 */
export function clickToToggleEnableDisableEmailNotificationTemplateSrc35Evid41(params) {
    return { evid: 41, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDisableEmailNotificationTemplateSrc35Evid42' event (evid: 42)
 *
 * Event description: When the user clicked to disable email notification from the modal
 *
 * @param {clickToDisableEmailNotificationTemplateSrc35Evid42Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToDisableEmailNotificationTemplateSrc35Evid42Params>} LogObject<clickToDisableEmailNotificationTemplateSrc35Evid42Params>
 */
export function clickToDisableEmailNotificationTemplateSrc35Evid42(params) {
    return { evid: 42, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCreateCustomEmailTemplateSrc35Evid43' event (evid: 43)
 *
 * Event description: When the user click to create a custom template
 *
 * @param {clickToCreateCustomEmailTemplateSrc35Evid43Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @return {LogObject<clickToCreateCustomEmailTemplateSrc35Evid43Params>} LogObject<clickToCreateCustomEmailTemplateSrc35Evid43Params>
 */
export function clickToCreateCustomEmailTemplateSrc35Evid43(params) {
    return { evid: 43, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDeleteCustomEmailTemplateSrc35Evid44' event (evid: 44)
 *
 * Event description: When the user click to delete a custom template
 *
 * @param {clickToDeleteCustomEmailTemplateSrc35Evid44Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToDeleteCustomEmailTemplateSrc35Evid44Params>} LogObject<clickToDeleteCustomEmailTemplateSrc35Evid44Params>
 */
export function clickToDeleteCustomEmailTemplateSrc35Evid44(params) {
    return { evid: 44, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToEditCustomEmailTemplateSrc35Evid45' event (evid: 45)
 *
 * Event description: When the user click to edit a custom template
 *
 * @param {clickToEditCustomEmailTemplateSrc35Evid45Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type which was clicked
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToEditCustomEmailTemplateSrc35Evid45Params>} LogObject<clickToEditCustomEmailTemplateSrc35Evid45Params>
 */
export function clickToEditCustomEmailTemplateSrc35Evid45(params) {
    return { evid: 45, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenPreviewCustomizeAssetsSrc35Evid46' event (evid: 46)
 *
 * Event description: When the user clicked to customize & preview one of the assets store credit / gift cards
 *
 * @param {clickToOpenPreviewCustomizeAssetsSrc35Evid46Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} assetName - The name of the asset which was clicked
 * @return {LogObject<clickToOpenPreviewCustomizeAssetsSrc35Evid46Params>} LogObject<clickToOpenPreviewCustomizeAssetsSrc35Evid46Params>
 */
export function clickToOpenPreviewCustomizeAssetsSrc35Evid46(params) {
    return { evid: 46, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEmailContentTabInEmailBuilderPageSrc35Evid47' event (evid: 47)
 *
 * Event description: When the user clicked on the email content tab to edit the email
 *
 * @param {clickOnEmailContentTabInEmailBuilderPageSrc35Evid47Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickOnEmailContentTabInEmailBuilderPageSrc35Evid47Params>} LogObject<clickOnEmailContentTabInEmailBuilderPageSrc35Evid47Params>
 */
export function clickOnEmailContentTabInEmailBuilderPageSrc35Evid47(params) {
    return { evid: 47, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToAddVariableToTheEmailBuilderTemplateSrc35Evid48' event (evid: 48)
 *
 * Event description: When the user clicked on one of the variable to add them into the template
 *
 * @param {clickToAddVariableToTheEmailBuilderTemplateSrc35Evid48Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @property {string} variableName - The variable name which added
 * @return {LogObject<clickToAddVariableToTheEmailBuilderTemplateSrc35Evid48Params>} LogObject<clickToAddVariableToTheEmailBuilderTemplateSrc35Evid48Params>
 */
export function clickToAddVariableToTheEmailBuilderTemplateSrc35Evid48(params) {
    return { evid: 48, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGlobalThemeTabInEmailBuilderPageSrc35Evid49' event (evid: 49)
 *
 * Event description: When the user clicked on the global theme tab to edit the email
 *
 * @param {clickOnGlobalThemeTabInEmailBuilderPageSrc35Evid49Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickOnGlobalThemeTabInEmailBuilderPageSrc35Evid49Params>} LogObject<clickOnGlobalThemeTabInEmailBuilderPageSrc35Evid49Params>
 */
export function clickOnGlobalThemeTabInEmailBuilderPageSrc35Evid49(params) {
    return { evid: 49, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid5' event (evid: 5)
 *
 * Event description: When the user click to add another price to the GC amounts in the gift card editor page
 *
 * @param {clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid5Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - From main page or from advanced editor for gift card variants
 * @return {LogObject<clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid5Params>} LogObject<clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid5Params>
 */
export function clickToAddAnotherPriceOptionToGiftCardVariantsSrc35Evid5(params) {
    return { evid: 5, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGlobalSettingTabInEmailBuilderPageSrc35Evid50' event (evid: 50)
 *
 * Event description: When the user clicked on the global setting tab to edit the email
 *
 * @param {clickOnGlobalSettingTabInEmailBuilderPageSrc35Evid50Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickOnGlobalSettingTabInEmailBuilderPageSrc35Evid50Params>} LogObject<clickOnGlobalSettingTabInEmailBuilderPageSrc35Evid50Params>
 */
export function clickOnGlobalSettingTabInEmailBuilderPageSrc35Evid50(params) {
    return { evid: 50, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEditWithCodeButtonInEmailBuilderPageSrc35Evid51' event (evid: 51)
 *
 * Event description: When the user clicked on the edit with code button to edit with code the email
 *
 * @param {clickOnEditWithCodeButtonInEmailBuilderPageSrc35Evid51Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickOnEditWithCodeButtonInEmailBuilderPageSrc35Evid51Params>} LogObject<clickOnEditWithCodeButtonInEmailBuilderPageSrc35Evid51Params>
 */
export function clickOnEditWithCodeButtonInEmailBuilderPageSrc35Evid51(params) {
    return { evid: 51, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSwitchToCodeEditorInEmailBuilderPageSrc35Evid52' event (evid: 52)
 *
 * Event description: When the user clicked to switch to the code editor in the email builder
 *
 * @param {clickToSwitchToCodeEditorInEmailBuilderPageSrc35Evid52Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToSwitchToCodeEditorInEmailBuilderPageSrc35Evid52Params>} LogObject<clickToSwitchToCodeEditorInEmailBuilderPageSrc35Evid52Params>
 */
export function clickToSwitchToCodeEditorInEmailBuilderPageSrc35Evid52(params) {
    return { evid: 52, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnResetToDefaultButtonInEmailBuilderPageSrc35Evid53' event (evid: 53)
 *
 * Event description: When the user clicked on the reset to default button to reset all the fields in the email template
 *
 * @param {clickOnResetToDefaultButtonInEmailBuilderPageSrc35Evid53Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickOnResetToDefaultButtonInEmailBuilderPageSrc35Evid53Params>} LogObject<clickOnResetToDefaultButtonInEmailBuilderPageSrc35Evid53Params>
 */
export function clickOnResetToDefaultButtonInEmailBuilderPageSrc35Evid53(params) {
    return { evid: 53, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToResetToDefaultInEmailBuilderPageSrc35Evid54' event (evid: 54)
 *
 * Event description: When the user clicked to reset the email template to default through the modal
 *
 * @param {clickToResetToDefaultInEmailBuilderPageSrc35Evid54Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToResetToDefaultInEmailBuilderPageSrc35Evid54Params>} LogObject<clickToResetToDefaultInEmailBuilderPageSrc35Evid54Params>
 */
export function clickToResetToDefaultInEmailBuilderPageSrc35Evid54(params) {
    return { evid: 54, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSaveEmailBuilderPageChangesSrc35Evid55' event (evid: 55)
 *
 * Event description: When the user clicked to save the template with the changes
 *
 * @param {clickToSaveEmailBuilderPageChangesSrc35Evid55Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @property {string} contentJson - If it's not a html builder the content json of the template will be sent
 * @return {LogObject<clickToSaveEmailBuilderPageChangesSrc35Evid55Params>} LogObject<clickToSaveEmailBuilderPageChangesSrc35Evid55Params>
 */
export function clickToSaveEmailBuilderPageChangesSrc35Evid55(params) {
    return { evid: 55, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToPreviewTestInEmailBuilderPageSrc35Evid56' event (evid: 56)
 *
 * Event description: When the user clicked to preview & test the template
 *
 * @param {clickToPreviewTestInEmailBuilderPageSrc35Evid56Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {GUID} templateId - The id of the template
 * @return {LogObject<clickToPreviewTestInEmailBuilderPageSrc35Evid56Params>} LogObject<clickToPreviewTestInEmailBuilderPageSrc35Evid56Params>
 */
export function clickToPreviewTestInEmailBuilderPageSrc35Evid56(params) {
    return { evid: 56, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenASettingFieldPageSrc35Evid57' event (evid: 57)
 *
 * Event description: When the user clicked on one of the the setting fields in the setting page
 *
 * @param {clickToOpenASettingFieldPageSrc35Evid57Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} settingField - business-setting, team-members, billing
 * @return {LogObject<clickToOpenASettingFieldPageSrc35Evid57Params>} LogObject<clickToOpenASettingFieldPageSrc35Evid57Params>
 */
export function clickToOpenASettingFieldPageSrc35Evid57(params) {
    return { evid: 57, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSaveBusinessSettingChangesSrc35Evid58' event (evid: 58)
 *
 * Event description: When the user Click to save business setting changes
 *
 * @param {clickToSaveBusinessSettingChangesSrc35Evid58Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} businessName - the saved business name
 * @property {string} businessEmail - the saved business email
 * @property {string} Industry - the saved industry value
 * @property {string} otherIndustryName - if the industry is other, then the name
 * @property {string} currency - the saved currency
 * @property {string} language - the saved language
 * @return {LogObject<clickToSaveBusinessSettingChangesSrc35Evid58Params>} LogObject<clickToSaveBusinessSettingChangesSrc35Evid58Params>
 */
export function clickToSaveBusinessSettingChangesSrc35Evid58(params) {
    return { evid: 58, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnInviteNewMemberInPermissionsSettingSrc35Evid59' event (evid: 59)
 *
 * Event description: When the user clicked on one of the the setting fields in the setting page
 *
 * @param {clickOnInviteNewMemberInPermissionsSettingSrc35Evid59Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnInviteNewMemberInPermissionsSettingSrc35Evid59Params>} LogObject<clickOnInviteNewMemberInPermissionsSettingSrc35Evid59Params>
 */
export function clickOnInviteNewMemberInPermissionsSettingSrc35Evid59(params) {
    return { evid: 59, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedToToggleOnOffAdvancedViewInGiftCardVariantsEditorSrc35Evid6' event (evid: 6)
 *
 * Event description: When the user change the radio button of the advance view of the Gift Card Editor
 *
 * @param {clickedToToggleOnOffAdvancedViewInGiftCardVariantsEditorSrc35Evid6Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {boolean} isOn - true when on
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickedToToggleOnOffAdvancedViewInGiftCardVariantsEditorSrc35Evid6Params>} LogObject<clickedToToggleOnOffAdvancedViewInGiftCardVariantsEditorSrc35Evid6Params>
 */
export function clickedToToggleOnOffAdvancedViewInGiftCardVariantsEditorSrc35Evid6(params) {
    return { evid: 6, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid60' event (evid: 60)
 *
 * Event description: When the user clicked on one of the the setting fields in the setting page
 *
 * @param {clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid60Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} role - the role the invitation sent with: admin / operator / custom
 * @return {LogObject<clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid60Params>} LogObject<clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid60Params>
 */
export function clickToSendAnInviteToANewAccountMemberInThePermissionsSettingSrc35Evid60(params) {
    return { evid: 60, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEditWithRegularEditorButtonInEmailBuilderPageSrc35Evid61' event (evid: 61)
 *
 * Event description: When the user clicked on the edit with regular editor button to edit with code the email
 *
 * @param {clickOnEditWithRegularEditorButtonInEmailBuilderPageSrc35Evid61Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {string} templateId - The id of the template
 * @return {LogObject<clickOnEditWithRegularEditorButtonInEmailBuilderPageSrc35Evid61Params>} LogObject<clickOnEditWithRegularEditorButtonInEmailBuilderPageSrc35Evid61Params>
 */
export function clickOnEditWithRegularEditorButtonInEmailBuilderPageSrc35Evid61(params) {
    return { evid: 61, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid62' event (evid: 62)
 *
 * Event description: When the user clicked to switch to the Regula editor in the email builder
 *
 * @param {clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid62Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} emailTypeName - The name of the email type the builder edit
 * @property {string} templateId - The id of the template
 * @return {LogObject<clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid62Params>} LogObject<clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid62Params>
 */
export function clickToSwitchToRegularEditorInEmailBuilderPageSrc35Evid62(params) {
    return { evid: 62, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSwitchBetweenAccountsSrc35Evid63' event (evid: 63)
 *
 * Event description: When the user clicked to switch between accounts through the header shop names
 *
 * @param {clickToSwitchBetweenAccountsSrc35Evid63Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - can't be provided at this event
 * @property {GUID} switchTo - The account id the user switched to
 * @return {LogObject<clickToSwitchBetweenAccountsSrc35Evid63Params>} LogObject<clickToSwitchBetweenAccountsSrc35Evid63Params>
 */
export function clickToSwitchBetweenAccountsSrc35Evid63(params) {
    return { evid: 63, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnASearchResultValueSrc35Evid64' event (evid: 64)
 *
 * Event description: When the user clicked on a value from the search bar
 *
 * @param {clickOnASearchResultValueSrc35Evid64Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} type - the type of the search result the user clicked on: gift_card / customer / ...
 * @return {LogObject<clickOnASearchResultValueSrc35Evid64Params>} LogObject<clickOnASearchResultValueSrc35Evid64Params>
 */
export function clickOnASearchResultValueSrc35Evid64(params) {
    return { evid: 64, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnRecommendedActionSrc35Evid65' event (evid: 65)
 *
 * Event description: When the user clicked on a quick action. mainly happen from the home page
 *
 * @param {clickOnRecommendedActionSrc35Evid65Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} action - customize gift card / customize program / issue batch ...
 * @return {LogObject<clickOnRecommendedActionSrc35Evid65Params>} LogObject<clickOnRecommendedActionSrc35Evid65Params>
 */
export function clickOnRecommendedActionSrc35Evid65(params) {
    return { evid: 65, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnAReadMoreArticleSrc35Evid66' event (evid: 66)
 *
 * Event description: When the user clicked on a recommended article, mainly happen from the home page.
 *
 * @param {clickOnAReadMoreArticleSrc35Evid66Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} articleName - the article name. i.e: how to sell gift cards / 3 ways... / store credit vs point ...
 * @return {LogObject<clickOnAReadMoreArticleSrc35Evid66Params>} LogObject<clickOnAReadMoreArticleSrc35Evid66Params>
 */
export function clickOnAReadMoreArticleSrc35Evid66(params) {
    return { evid: 66, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDisableAWorkflowSrc35Evid67' event (evid: 67)
 *
 * Event description: When the user clicked to disabled a workflow
 *
 * @param {clickToDisableAWorkflowSrc35Evid67Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @return {LogObject<clickToDisableAWorkflowSrc35Evid67Params>} LogObject<clickToDisableAWorkflowSrc35Evid67Params>
 */
export function clickToDisableAWorkflowSrc35Evid67(params) {
    return { evid: 67, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDeleteAWorkflowSrc35Evid68' event (evid: 68)
 *
 * Event description: When the user clicked to Delete a workflow
 *
 * @param {clickToDeleteAWorkflowSrc35Evid68Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @return {LogObject<clickToDeleteAWorkflowSrc35Evid68Params>} LogObject<clickToDeleteAWorkflowSrc35Evid68Params>
 */
export function clickToDeleteAWorkflowSrc35Evid68(params) {
    return { evid: 68, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheActiveDisabledAWorkflowToggleSrc35Evid69' event (evid: 69)
 *
 * Event description: When the user clicked to switch the state of the active / disabled workflow state toggle
 *
 *
 * @param {clickOnTheActiveDisabledAWorkflowToggleSrc35Evid69Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} switch_to - active / disabled
 * @return {LogObject<clickOnTheActiveDisabledAWorkflowToggleSrc35Evid69Params>} LogObject<clickOnTheActiveDisabledAWorkflowToggleSrc35Evid69Params>
 */
export function clickOnTheActiveDisabledAWorkflowToggleSrc35Evid69(params) {
    return { evid: 69, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToAddAnImageToAGiftCardVariantSrc35Evid7' event (evid: 7)
 *
 * Event description: When the user clicked to add an image to a gift card variant in the advanced editor
 *
 * @param {clickToAddAnImageToAGiftCardVariantSrc35Evid7Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - From main page or from advanced editor for gift card variants
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToAddAnImageToAGiftCardVariantSrc35Evid7Params>} LogObject<clickToAddAnImageToAGiftCardVariantSrc35Evid7Params>
 */
export function clickToAddAnImageToAGiftCardVariantSrc35Evid7(params) {
    return { evid: 7, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnLearnMore' event (evid: 70)
 *
 * Event description: When the user clicked on the "learn more" link from one of the entry points
 *
 * @param {clickOnLearnMoreParams} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID (msid)
 * @property {string} articleName - article name (null if not exist)
 * @property {string} origin - text link / etc
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnLearnMoreParams>} LogObject<clickOnLearnMoreParams>
 */
export function clickOnLearnMore(params) {
    return { evid: 70, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCreateAWorkflowSrc35Evid71' event (evid: 71)
 *
 * Event description: When the user clicked on the dropdown of the creating a new workflow from scratch or from customize preset
 *
 * @param {clickToCreateAWorkflowSrc35Evid71Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} type - the creation type
 * @return {LogObject<clickToCreateAWorkflowSrc35Evid71Params>} LogObject<clickToCreateAWorkflowSrc35Evid71Params>
 */
export function clickToCreateAWorkflowSrc35Evid71(params) {
    return { evid: 71, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheAskForHelpSrc35Evid72' event (evid: 72)
 *
 * Event description: When the user clicked on the intercom icon, in order to get customer support help
 *
 * @param {clickOnTheAskForHelpSrc35Evid72Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @return {LogObject<clickOnTheAskForHelpSrc35Evid72Params>} LogObject<clickOnTheAskForHelpSrc35Evid72Params>
 */
export function clickOnTheAskForHelpSrc35Evid72(params) {
    return { evid: 72, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToGoToOrdersToIssueRefundWithScSrc35Evid73' event (evid: 73)
 *
 * Event description: When the user clicked on "Go to orders" button, in order to issue a refund using Rise store credit
 *
 * @param {clickToGoToOrdersToIssueRefundWithScSrc35Evid73Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The specific place the button was clicked from
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToGoToOrdersToIssueRefundWithScSrc35Evid73Params>} LogObject<clickToGoToOrdersToIssueRefundWithScSrc35Evid73Params>
 */
export function clickToGoToOrdersToIssueRefundWithScSrc35Evid73(params) {
    return { evid: 73, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToAddGiftCardProductSrc35Evid74' event (evid: 74)
 *
 * Event description: When the user entered for the 1st time to the gift card product page and clicked on the CTE to create a new product
 *
 * @param {clickToAddGiftCardProductSrc35Evid74Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} sourceTenantId - The shop associated with the action
 * @return {LogObject<clickToAddGiftCardProductSrc35Evid74Params>} LogObject<clickToAddGiftCardProductSrc35Evid74Params>
 */
export function clickToAddGiftCardProductSrc35Evid74(params) {
    return { evid: 74, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCreateEmailNotificationTemplateSrc35Evid75' event (evid: 75)
 *
 * Event description: When the user click to create email notification template from scratch
 *
 * @param {clickToCreateEmailNotificationTemplateSrc35Evid75Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @return {LogObject<clickToCreateEmailNotificationTemplateSrc35Evid75Params>} LogObject<clickToCreateEmailNotificationTemplateSrc35Evid75Params>
 */
export function clickToCreateEmailNotificationTemplateSrc35Evid75(params) {
    return { evid: 75, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToGenerateReportSrc35Evid76' event (evid: 76)
 *
 * Event description: When the user click to open the report modal
 *
 * @param {clickToGenerateReportSrc35Evid76Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} reportName - The name of the generated report ( history / liability.. )
 * @return {LogObject<clickToGenerateReportSrc35Evid76Params>} LogObject<clickToGenerateReportSrc35Evid76Params>
 */
export function clickToGenerateReportSrc35Evid76(params) {
    return { evid: 76, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToOpenDeveloperToolSrc35Evid77' event (evid: 77)
 *
 * Event description: When the user clicked on one of the developer tools
 *
 * @param {clickToOpenDeveloperToolSrc35Evid77Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} developerToolName - set_up_webhooks / api_keys
 * @return {LogObject<clickToOpenDeveloperToolSrc35Evid77Params>} LogObject<clickToOpenDeveloperToolSrc35Evid77Params>
 */
export function clickToOpenDeveloperToolSrc35Evid77(params) {
    return { evid: 77, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheCreateWebhookButtonSrc35Evid78' event (evid: 78)
 *
 * Event description: When the user click on the button to create a webhook
 *
 * @param {clickOnTheCreateWebhookButtonSrc35Evid78Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - the place in the page the button was placed at
 * @return {LogObject<clickOnTheCreateWebhookButtonSrc35Evid78Params>} LogObject<clickOnTheCreateWebhookButtonSrc35Evid78Params>
 */
export function clickOnTheCreateWebhookButtonSrc35Evid78(params) {
    return { evid: 78, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToCreateWebhookSrc35Evid79' event (evid: 79)
 *
 * Event description: When the user click to create a new webhook
 *
 * @param {clickToCreateWebhookSrc35Evid79Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @return {LogObject<clickToCreateWebhookSrc35Evid79Params>} LogObject<clickToCreateWebhookSrc35Evid79Params>
 */
export function clickToCreateWebhookSrc35Evid79(params) {
    return { evid: 79, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid8' event (evid: 8)
 *
 * Event description: When the user choose expiration type of the Gift Cards in editor page
 *
 * @param {clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid8Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} type - never / time_period
 * @return {LogObject<clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid8Params>} LogObject<clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid8Params>
 */
export function clickToChooseExpirationTypeOfTheGiftCardsInEditorPageSrc35Evid8(params) {
    return { evid: 8, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnAnIntegrationApplicationSrc35Evid80' event (evid: 80)
 *
 * Event description: When the user clicked on one of the applications to integrate with
 *
 * @param {clickOnAnIntegrationApplicationSrc35Evid80Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} appName - the app name the user clicked on
 * @property {string} appTabName - The tab from which the application was opened (All Apps / Returns / Reviews / Marketing Automations / Other)
 * @property {string} appStatus - Disabled / Enabled ("Disabled" is not visible to the user)
 * @property {string} connectionMethod - What is the next page the use see after the click: app page / support
 * @return {LogObject<clickOnAnIntegrationApplicationSrc35Evid80Params>} LogObject<clickOnAnIntegrationApplicationSrc35Evid80Params>
 */
export function clickOnAnIntegrationApplicationSrc35Evid80(params) {
    return { evid: 80, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToExportReportSrc35Evid81' event (evid: 81)
 *
 * Event description: When the user click to export the report from the modal
 *
 * @param {clickToExportReportSrc35Evid81Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} reportName - The name of the generated report ( history / liability.. )
 * @property {string} payload - The exported report features
 * @return {LogObject<clickToExportReportSrc35Evid81Params>} LogObject<clickToExportReportSrc35Evid81Params>
 */
export function clickToExportReportSrc35Evid81(params) {
    return { evid: 81, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToGenerateApiKeySrc35Evid82' event (evid: 82)
 *
 * Event description: When the user click to create a new API key
 *
 * @param {clickToGenerateApiKeySrc35Evid82Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToGenerateApiKeySrc35Evid82Params>} LogObject<clickToGenerateApiKeySrc35Evid82Params>
 */
export function clickToGenerateApiKeySrc35Evid82(params) {
    return { evid: 82, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToViewDeveloperToolDocumentationSrc35Evid83' event (evid: 83)
 *
 * Event description: When the user click to view the developer tool documentation
 *
 * @param {clickToViewDeveloperToolDocumentationSrc35Evid83Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToViewDeveloperToolDocumentationSrc35Evid83Params>} LogObject<clickToViewDeveloperToolDocumentationSrc35Evid83Params>
 */
export function clickToViewDeveloperToolDocumentationSrc35Evid83(params) {
    return { evid: 83, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToViewDeveloperToolAccountIdSrc35Evid84' event (evid: 84)
 *
 * Event description: When the user click to view the developer tool account ID
 *
 * @param {clickToViewDeveloperToolAccountIdSrc35Evid84Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToViewDeveloperToolAccountIdSrc35Evid84Params>} LogObject<clickToViewDeveloperToolAccountIdSrc35Evid84Params>
 */
export function clickToViewDeveloperToolAccountIdSrc35Evid84(params) {
    return { evid: 84, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToViewDeveloperToolPublicKeysSrc35Evid85' event (evid: 85)
 *
 * Event description: When the user click to view the developer tool Public Keys
 *
 * @param {clickToViewDeveloperToolPublicKeysSrc35Evid85Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} origin - The place the button was located
 * @return {LogObject<clickToViewDeveloperToolPublicKeysSrc35Evid85Params>} LogObject<clickToViewDeveloperToolPublicKeysSrc35Evid85Params>
 */
export function clickToViewDeveloperToolPublicKeysSrc35Evid85(params) {
    return { evid: 85, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToEnableAppIntegrationSrc35Evid86' event (evid: 86)
 *
 * Event description: When the user click to enable the integration to the app
 *
 * @param {clickToEnableAppIntegrationSrc35Evid86Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} appName - the app name related to the action
 * @return {LogObject<clickToEnableAppIntegrationSrc35Evid86Params>} LogObject<clickToEnableAppIntegrationSrc35Evid86Params>
 */
export function clickToEnableAppIntegrationSrc35Evid86(params) {
    return { evid: 86, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDisableAppIntegrationSrc35Evid87' event (evid: 87)
 *
 * Event description: When the user click to disable the integration to the app
 *
 * @param {clickToDisableAppIntegrationSrc35Evid87Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} appName - the app name related to the action
 * @return {LogObject<clickToDisableAppIntegrationSrc35Evid87Params>} LogObject<clickToDisableAppIntegrationSrc35Evid87Params>
 */
export function clickToDisableAppIntegrationSrc35Evid87(params) {
    return { evid: 87, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToRemoveAppIntegrationSrc35Evid88' event (evid: 88)
 *
 * Event description: When the user click to remove the integration to the app
 *
 * @param {clickToRemoveAppIntegrationSrc35Evid88Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @property {string} appName - the app name related to the action
 * @return {LogObject<clickToRemoveAppIntegrationSrc35Evid88Params>} LogObject<clickToRemoveAppIntegrationSrc35Evid88Params>
 */
export function clickToRemoveAppIntegrationSrc35Evid88(params) {
    return { evid: 88, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'riseWixPluginLoadingInitiatedSrc35Evid89' event (evid: 89)
 *
 * Event description: When Rise on Wix plug in started to load
 * currently there is only the quick apply plug-in in a checkout slot
 *
 * @param {riseWixPluginLoadingInitiatedSrc35Evid89Params} params - The parameters for this event
 * @property {GUID} visitor_id - Wix visitor id
 * @property {GUID} appId - plug-in app id
 * @property {string} appName - plug-in app name
 * @return {LogObject<riseWixPluginLoadingInitiatedSrc35Evid89Params>} LogObject<riseWixPluginLoadingInitiatedSrc35Evid89Params>
 */
export function riseWixPluginLoadingInitiatedSrc35Evid89(params) {
    return { evid: 89, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToSaveGiftCardPropertiesInGiftCardEditorPageSrc35Evid9' event (evid: 9)
 *
 * Event description: When the user clicked to save the changes which were made in the editor page
 *
 * @param {clickToSaveGiftCardPropertiesInGiftCardEditorPageSrc35Evid9Params} params - The parameters for this event
 * @property {string} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} productName - the saved product name
 * @property {string} description - the saved GC description
 * @property {boolean} isMainImage - True if there is an image in the GC
 * @property {boolean} isAdvancedEditorVariants - True if the toggle of advanced saved with on
 * @property {string} giftCardVariants - A list of the saved GC variants: [[price1,value1,image1(T/F)],[price2,value2,image2(T/F)]]
 * @property {string} expirationType - saved expiration type never / time_period
 * @property {string} timePeriodType - year / day / null
 * @property {number} timePeriodValue - number of days / years the user choose / null
 * @return {LogObject<clickToSaveGiftCardPropertiesInGiftCardEditorPageSrc35Evid9Params>} LogObject<clickToSaveGiftCardPropertiesInGiftCardEditorPageSrc35Evid9Params>
 */
export function clickToSaveGiftCardPropertiesInGiftCardEditorPageSrc35Evid9(params) {
    return { evid: 9, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickToDownloadExportedButchResultsSrc35Evid90' event (evid: 90)
 *
 * Event description: When the user clicked through the pop-up to download the exported butch resoltes
 *
 * @param {clickToDownloadExportedButchResultsSrc35Evid90Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} batchId - The id of the exported batch
 * @return {LogObject<clickToDownloadExportedButchResultsSrc35Evid90Params>} LogObject<clickToDownloadExportedButchResultsSrc35Evid90Params>
 */
export function clickToDownloadExportedButchResultsSrc35Evid90(params) {
    return { evid: 90, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheMainCreateWorkflowButtonSrc35Evid91' event (evid: 91)
 *
 * Event description: When the user clicked on the main CTE of the creation of new workflow
 *
 * @param {clickOnTheMainCreateWorkflowButtonSrc35Evid91Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page the action was created from
 * @return {LogObject<clickOnTheMainCreateWorkflowButtonSrc35Evid91Params>} LogObject<clickOnTheMainCreateWorkflowButtonSrc35Evid91Params>
 */
export function clickOnTheMainCreateWorkflowButtonSrc35Evid91(params) {
    return { evid: 91, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedToSwitchBetweenWorkflowsPresetTabsSrc35Evid92' event (evid: 92)
 *
 * Event description: When the user clicked to switch between the workflow preset charges
 *
 * @param {clickedToSwitchBetweenWorkflowsPresetTabsSrc35Evid92Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} tabName - The tab the user clicked on
 * @return {LogObject<clickedToSwitchBetweenWorkflowsPresetTabsSrc35Evid92Params>} LogObject<clickedToSwitchBetweenWorkflowsPresetTabsSrc35Evid92Params>
 */
export function clickedToSwitchBetweenWorkflowsPresetTabsSrc35Evid92(params) {
    return { evid: 92, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedToOpenWorkflowPresetModalFromTheMainPageSrc35Evid93' event (evid: 93)
 *
 * Event description: When the user  clicked to open workflow preset modal
 *
 * @param {clickedToOpenWorkflowPresetModalFromTheMainPageSrc35Evid93Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - The origin of the action
 * @property {string} presetName - The preset the user clicked on
 * @return {LogObject<clickedToOpenWorkflowPresetModalFromTheMainPageSrc35Evid93Params>} LogObject<clickedToOpenWorkflowPresetModalFromTheMainPageSrc35Evid93Params>
 */
export function clickedToOpenWorkflowPresetModalFromTheMainPageSrc35Evid93(params) {
    return { evid: 93, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedToChooseBetweenWorkflowPresetsInTheWorkflowsPresetModalSrc35Evid94' event (evid: 94)
 *
 * Event description: When the user  Clicked to choose between workflow presets in the workflows preset modal
 *
 * @param {clickedToChooseBetweenWorkflowPresetsInTheWorkflowsPresetModalSrc35Evid94Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} origin - the origin
 * @property {string} presetName - The preset the user clicked on
 * @return {LogObject<clickedToChooseBetweenWorkflowPresetsInTheWorkflowsPresetModalSrc35Evid94Params>} LogObject<clickedToChooseBetweenWorkflowPresetsInTheWorkflowsPresetModalSrc35Evid94Params>
 */
export function clickedToChooseBetweenWorkflowPresetsInTheWorkflowsPresetModalSrc35Evid94(params) {
    return { evid: 94, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedToSetUpANewWorkflowPresetSrc35Evid95' event (evid: 95)
 *
 * Event description: When the user clicked to  set up a new workflow preset (continue to the automation tool)
 *
 * @param {clickedToSetUpANewWorkflowPresetSrc35Evid95Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {string} channelId - the channel_id where the preset workflow was created
 * @property {string} presetName - the name of the selected preset
 * @return {LogObject<clickedToSetUpANewWorkflowPresetSrc35Evid95Params>} LogObject<clickedToSetUpANewWorkflowPresetSrc35Evid95Params>
 */
export function clickedToSetUpANewWorkflowPresetSrc35Evid95(params) {
    return { evid: 95, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnGoToAppButtonInTheIntegrationPageSrc35Evid96' event (evid: 96)
 *
 * Event description: When the user clicked on "Go to" app button.
 * pageName column = which app was triggered
 *
 * @param {clickOnGoToAppButtonInTheIntegrationPageSrc35Evid96Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnGoToAppButtonInTheIntegrationPageSrc35Evid96Params>} LogObject<clickOnGoToAppButtonInTheIntegrationPageSrc35Evid96Params>
 */
export function clickOnGoToAppButtonInTheIntegrationPageSrc35Evid96(params) {
    return { evid: 96, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnEnableAppButtonInTheIntegrationPageSrc35Evid97' event (evid: 97)
 *
 * Event description: When the user clicked on "Enable" app button
 *
 * @param {clickOnEnableAppButtonInTheIntegrationPageSrc35Evid97Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @property {boolean} hasIntegrationSucceed - True if the integration was successful, false if not.
 * @return {LogObject<clickOnEnableAppButtonInTheIntegrationPageSrc35Evid97Params>} LogObject<clickOnEnableAppButtonInTheIntegrationPageSrc35Evid97Params>
 */
export function clickOnEnableAppButtonInTheIntegrationPageSrc35Evid97(params) {
    return { evid: 97, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnCreateAWorkflowInIntegrationPageSrc35Evid98' event (evid: 98)
 *
 * Event description: When the user clicked on "Create a Workflow" app button after the integration succeed
 *
 * @param {clickOnCreateAWorkflowInIntegrationPageSrc35Evid98Params} params - The parameters for this event
 * @property {GUID} accountMsid - The Account ID
 * @property {string} pageName - The page name where the action was created at
 * @return {LogObject<clickOnCreateAWorkflowInIntegrationPageSrc35Evid98Params>} LogObject<clickOnCreateAWorkflowInIntegrationPageSrc35Evid98Params>
 */
export function clickOnCreateAWorkflowInIntegrationPageSrc35Evid98(params) {
    return { evid: 98, src: 35, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTheUpgradePlanButtonLinkSrc35Evid99' event (evid: 99)
 *
 * Event description: When the user clicked on one of the upgrades links or buttons in order to upgrade the plan to use the features
 *
 * @param {clickOnTheUpgradePlanButtonLinkSrc35Evid99Params} params - The parameters for this event
 * @property {GUID} accountMsid - Rise Account ID
 * @property {string} pageName - The page name the clicked was on
 * @property {string} buttonName - The name of the button if exist
 * @property {string} origin - The origin the click was created from
 * @return {LogObject<clickOnTheUpgradePlanButtonLinkSrc35Evid99Params>} LogObject<clickOnTheUpgradePlanButtonLinkSrc35Evid99Params>
 */
export function clickOnTheUpgradePlanButtonLinkSrc35Evid99(params) {
    return { evid: 99, src: 35, endpoint: '', params };
}
//# sourceMappingURL=index.js.map